// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-27T16:59:11.755Z
// Property: The Club at Eagle Pointe (ID: 6767906449167268)
// Collections: 25 amenities, 3 floorplans (live), 18 photos, 73 POIs, 1 reviews, 3 virtual tours, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167268",
  "property_external_id": "1101829",
  "property_zillow_url": "https://www.zillow.com/apartments/anchorage-ak/the-club-at-eagle-point/CkB9CY/",
  "property_apartments_url": "https://www.apartments.com/the-club-at-eagle-point-anchorage-ak/y052vlr/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Club+at+Eagle+Pointe/data=!4m2!3m1!1s0x0:0xb5c3f886dd31e25d?sa=X&ved=2ahUKEwia3Jjbr4STAxVEQ_EDHSUaFz0Q_BJ6BAgPEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47586141841",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-club-at-eagle-pointe",
  "property_name": "The Club at Eagle Pointe",
  "property_website_url": "https://www.clubateaglepointe.com/",
  "property_domain": "https://www.clubateaglepointe.com/",
  "property_address": "5640 Lake Otis Pkwy",
  "property_full_address": "5640 Lake Otis Pkwy, Anchorage, AK 99507",
  "property_address_1": "5640 Lake Otis Pkwy",
  "property_address_2": null,
  "property_address_city": "Anchorage",
  "property_address_state": "AK",
  "property_address_zip_full": null,
  "property_address_zip": "99507",
  "property_address_country": "US",
  "property_address_county": "Anchorage Municipality",
  "property_neighborhood_address": "Campbell Park",
  "property_address_latitude": "61.16957",
  "property_address_longitude": "-149.83967",
  "property_email": "theclub@weidner.com",
  "property_phone": "(907) 308-5613",
  "property_call_tracking_phone": "907-308-5613",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Modern one-bedroom living in Campbell Park.</strong> Remodeled, furnished layouts with large closets, energy-efficient appliances, and a patio or balcony create a polished Anchorage home base—explore The Club at Eagle Pointe and schedule your tour today.</p>",
  "property_long_description": "<p><strong>Modern one-bedroom living in Campbell Park.</strong> At The Club at Eagle Pointe, you can settle into a polished Anchorage home base with remodeled and furnished <a href=\"/floor-plans\">one-bedroom layouts</a>, large closets, ceiling fans, energy-efficient appliances, and the everyday bonus of a patio or balcony. Select homes add granite countertops, stainless steel appliances, and mountain or neighborhood views.</p><p>Step outside your door for a practical, well-connected lifestyle: work out in the fitness center, grab coffee in the clubhouse with Wi-Fi, use the business center, or unwind in the resident lounge and courtyard. Online payments, on-site management, courtesy patrol, and 24-hour emergency maintenance keep the details simple. From Lake Otis Parkway, you’re close to Campbell Park, the Campbell Creek Trail, Alaska Pacific University, UAA, Tudor Road dining, nearby shopping, and People Mover service along Lake Otis—putting parks, errands, and Anchorage essentials within easy reach. Explore more <a href=\"/amenities\">community amenities</a> or take a closer look around the <a href=\"/neighborhood\">Campbell Park neighborhood</a>.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/01a07558-2ef7-779c-99ba-87a2f70baa7e.webp",
  "property_featured_image_media": {
    "alt_text": "Empty bedroom with two bi-fold closets and a ceiling fan.",
    "public_id": "01a07558-2ef7-779c-99ba-87a2f70baa7e",
    "storage_key": "property/6767906449167268/01a07558-2ef7-779c-99ba-87a2f70baa7e.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "285",
  "property_year_built": "1982",
  "property_year_renovated": null,
  "property_walk_score": "68",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.19298245614036",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "40",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://clubateaglepointe.securecafe.com/onlineleasing/the-club-at-eagle-point/floorplans.aspx",
  "property_resident_portal_url": "https://clubateaglepointe.securecafenet.com/residentservices/the-club-at-eagle-point/userlogin",
  "property_apply_now_url": "https://clubateaglepointe.securecafe.com/onlineleasing/the-club-at-eagle-point/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022b-ac33-70f0-946a-acb444977a54.webp",
  "property_primary_logo_media": {
    "alt_text": "The Club at Eagle Pointe Apartment Homes logo.",
    "public_id": "019d022b-ac33-70f0-946a-acb444977a54",
    "storage_key": "property/6767906449167268/019d022b-ac33-70f0-946a-acb444977a54.webp",
    "width": 517,
    "height": 401
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022d-9350-7004-8582-85c4350e0639.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Club at Eagle Pointe Apartment Homes logo",
    "public_id": "019d022d-9350-7004-8582-85c4350e0639",
    "storage_key": "property/6767906449167268/019d022d-9350-7004-8582-85c4350e0639.webp",
    "width": 517,
    "height": 401
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022d-9a91-7276-b58e-1faa0a4fa35e.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Club at Eagle Pointe Apartment Homes logo",
    "public_id": "019d022d-9a91-7276-b58e-1faa0a4fa35e",
    "storage_key": "property/6767906449167268/019d022d-9a91-7276-b58e-1faa0a4fa35e.webp",
    "width": 517,
    "height": 401
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#C1652F",
  "property_secondary_color": "#7A3F1D",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#D9B08C",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 1",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "1",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": " - 470",
  "property_sqft_min": "470",
  "property_sqft_max": "470",
  "property_price_range": "950 - 1919",
  "property_price_min": "950",
  "property_price_max": "1919",
  "property_available_units": 11,
  "property_facebook_url": "https://www.facebook.com/TheClubAtEaglePointeApartments",
  "property_instagram_url": "https://www.instagram.com/theclubateaglepointe/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJU2GomHSXyFYRXeIx3Yb4w7U",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Club at Eagle Pointe",
  "property_home_romance_title": "Embrace the Joy of Living in Your Perfect Home",
  "property_home_amenities_blurb": "<p><strong>Everyday amenities, Anchorage ease.</strong> Keep your routine moving with a fitness center, business center, Wi-Fi clubhouse, resident lounge, and courtyard—all close to home. Online payments, service requests, on-site teams, courtesy patrol, and 24-hour emergency maintenance help streamline the details, while one-bedroom apartments add large closets, efficient appliances, and a private patio or balcony. Select remodeled homes bring granite countertops, stainless steel appliances, and upgraded finishes.</p>",
  "property_home_floorplans_blurb": "<p><strong>One-bedroom living, three streamlined ways.</strong> Eagles Nest floor plans at The Club at Eagle Pointe pair a defined bedroom with large closet space, ceiling fans, energy-efficient appliances, and a private patio or balcony. Keep it classic, choose remodeled finishes like granite countertops and stainless steel appliances in select homes, or go furnished for a more ready-to-go Anchorage setup. Browse featured layouts, pricing, and availability to find the finish level and timing that fit.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview the picture-perfect details.</strong> Browse warm wood cabinetry, sleek select-kitchen appliances, sunlit living rooms, and smart bedroom storage—then look beyond the apartment to clubhouse seating by the fireplace, window-lined cardio space, an indoor spa, and Anchorage views from patios or balconies.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Anchorage connections, Campbell Park calm.</strong> From The Club at Eagle Pointe, Lake Otis Parkway keeps University-Medical District, Midtown dining, and southside shopping within easy reach. Spend the day between Moose’s Tooth, Kinley’s, Taku Lake Park, and the Campbell Creek Trail, with Far North Bicentennial Park and the Alaska Botanical Garden nearby for bigger outdoor plans. Explore the map to see what’s close to home.</p>",
  "property_home_reviews_blurb": "<p><strong>Reviews that start with standout service.</strong> Residents point to an “amazing” team, helpful everyday support, and amenities that fit real routines—including the exercise room, where one reviewer celebrated a personal wellness milestone. Read more to see why residents describe The Club at Eagle Pointe as a place that makes them ask, “why would I want to live anywhere else” in Anchorage.</p>",
  "property_neighborhood_blurb": "<p><strong>Put Anchorage on your everyday map.</strong> From The Club at Eagle Pointe in Campbell Park, Lake Otis Parkway gives you a straightforward line to the University-Medical District, Midtown dining, and southside shopping without losing the neighborhood’s green-space feel. Follow the map to local standouts like Moose’s Tooth Pub &amp; Pizzeria, Kinley’s Restaurant &amp; Bar, Taku Lake Park, and the Campbell Creek Trail, where bike rides, creekside walks, and city errands can all fit into the same day. Far North Bicentennial Park and the Alaska Botanical Garden add even more room to explore, while People Mover Route 55 along Lake Otis connects toward ANMC and Dimond Center. Browse the nearby highlights, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how this connected Anchorage location works for you.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that keep your routine moving.</strong> At The Club at Eagle Pointe, you can start the day in the fitness center, answer a few emails in the business center or Wi-Fi clubhouse, then take a coffee break without leaving the community. The resident lounge and courtyard add easy places to reset, while online payments, service requests, on-site teams, courtesy patrol, and 24-hour emergency maintenance help simplify the details of apartment living in Anchorage.</p><p>Inside your one-bedroom home, practical comforts do the heavy lifting: large closets, ceiling fans, efficient appliances, a linen closet, and your own patio or balcony. Select remodeled homes add granite countertops, stainless steel appliances, and upgraded finishes for a more polished everyday backdrop. Browse the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the spaces in person.</p>",
  "property_applynow_blurb": "<p><strong>Start your application for The Club at Eagle Pointe.</strong><br>Choose a remodeled, furnished one-bedroom home with large closets, energy-efficient appliances, and a patio or balcony. With online payments, on-site management, and 24-hour emergency maintenance, everyday living is designed to feel simple from the start.</p>",
  "property_contactus_blurb": "<p><strong>Questions? We’re here to help.</strong> Contact The Club at Eagle Pointe leasing team to learn more about remodeled one-bedroom layouts, select upgraded finishes, and everyday conveniences—or to get directions to our Lake Otis Parkway community in Campbell Park.</p>",
  "property_faqs_blurb": "<p><strong>Questions about The Club at Eagle Pointe?</strong> Start here for quick answers about remodeled one-bedroom layouts, furnished options, leasing, amenities, and everyday living in Campbell Park. If you need more details or want help choosing your next step, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Compare three takes on streamlined one-bedroom living.</strong> At The Club at Eagle Pointe, every Eagles Nest layout gives you a manageable Anchorage retreat with the essentials that make daily routines feel easier: a defined bedroom, large closet space, ceiling fans, energy-efficient appliances, and your own patio or balcony. Choose the classic plan for simple comfort, the remodeled option for upgraded finishes such as granite countertops and stainless steel appliances in select homes, or a furnished layout when you want a more ready-to-go setup.</p><p>Browse current pricing and availability below, then use the cards to match the finish level, view, and move-in timing that work best for you. Want to see the details in person? <a href=\"/schedule-a-tour\">Schedule a tour</a> or compare more <a href=\"/amenities\">apartment features</a>.</p>",
  "property_gallery_blurb": "<p><strong>See the details before you step inside.</strong> The gallery at The Club at Eagle Pointe brings the community into focus: warm wood cabinetry and sleek appliances in select kitchens, sunlit living spaces with soft neutral finishes, and bedrooms arranged around practical storage.</p><p>Scroll from apartment interiors to shared spaces—the resident lounge with leather seating and a fireplace, bright clubhouse corners for coffee or Wi-Fi time, cardio equipment by the windows, and an indoor spa scene framed by natural light. You’ll also catch patios or balconies and outdoor views that add an Anchorage backdrop to everyday routines. When a photo sparks a must-see detail, compare <a href=\"/floor-plans\">available one-bedroom layouts</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the finishes and community spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore what’s close.</strong> Use the interactive map to browse available one-bedroom apartments and see how The Club at Eagle Pointe connects to Campbell Park, nearby trails, dining, shopping, transit, and Anchorage essentials from Lake Otis Parkway.</p>",
  "property_pets_blurb": "<p><strong>Room for your pet’s daily routine.</strong> At The Club at Eagle Pointe, your cat or dog can settle in with you, with up to two pets welcome per home and no weight limit noted in the posted policy. Step out for fresh air in the courtyard, use nearby walking paths for quick leash breaks, or make your patio or balcony part of your pet’s favorite routine. When a longer outing is calling, Campbell Park’s trail access and Anchorage off-leash areas put more sniff-worthy options within reach without turning pet care into a production. Browse <a href=\"/amenities\">community features</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how pet-friendly living fits your day.</p>",
  "property_referafriend_blurb": "<p><strong>Share the Anchorage home base you love.</strong><br>Refer a friend to The Club at Eagle Pointe and invite them to discover remodeled one-bedroom living, furnished layouts, everyday conveniences, and community spaces that make life in Campbell Park feel simple and connected.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access made simple.</strong> Pay rent online, submit maintenance requests, and manage your account for The Club at Eagle Pointe in one convenient place. With on-site management and 24-hour emergency maintenance, everyday details stay streamlined.</p>",
  "property_reviews_blurb": "<p><strong>Resident feedback starts with the team.</strong> In one 5-star review, a resident describes The Club at Eagle Pointe staff simply: “This team here is amazing.” You’ll also see appreciation for the exercise room as part of a steady daily routine, with the same resident sharing a personal wellness milestone connected to using it.</p><p>As you browse the reviews, look for the details that matter in everyday apartment living: helpful service, a community that supports your schedule, and experiences that make residents say, “why would I want to live anywhere else” in Anchorage.</p>",
  "property_created_at": "1771544386946",
  "property_scheduletour_blurb": "<p><strong>See modern Campbell Park living up close.</strong> Tour remodeled one-bedroom layouts with large closets, energy-efficient appliances, and a patio or balcony—plus select finishes like granite, stainless steel, and views. Then picture the clubhouse, fitness center, lounge, and courtyard in your routine. Schedule your tour today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong><br>The leasing team at The Club at Eagle Pointe will follow up soon. In the meantime, picture modern one-bedroom living in Campbell Park, with remodeled interiors, large closets, energy-efficient appliances, and a patio or balcony to make your Anchorage home base feel complete.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside before you arrive.</strong> Use the virtual tours to move through The Club at Eagle Pointe at your own pace, starting with the clubhouse, where Wi-Fi-ready gathering space and comfortable lounge areas help you picture everyday downtime beyond your front door.</p><p>Then compare the Eagles Nest and Eagles Nest Remodeled apartment tours side by side. Look for the flow from living area to kitchen, the storage that supports a streamlined one-bedroom layout, and finish differences that stand out in the remodeled option, including select upgraded counters and appliances. When you’re ready to connect what you see online with current availability, browse <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> for a closer look in Anchorage.</p>",
  "property_copyright": "2026 All Rights Reserved. The Club at Eagle Pointe",
  "property_seo_title_home": "Apartments for Rent - The Club at Eagle Pointe - Anchorage, AK",
  "property_seo_description_home": "Discover one-bedroom apartments at The Club at Eagle Pointe in Anchorage, AK. Enjoy pet-friendly living, community amenities, and vibrant Campbell Park.",
  "property_seo_title_floorplans": "Floor Plans | Anchorage, AK Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal retreat at The Club at Eagle Pointe in Anchorage, AK. Browse our one-bedroom floor plans and envision your new lifestyle today!",
  "property_seo_title_amenities": "Amenities | Anchorage, AK Apartments for Rent",
  "property_seo_description_amenities": "Elevate your living at The Club at Eagle Pointe in Anchorage! Enjoy upscale amenities, from fitness facilities to social events. Your ideal home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Anchorage, AK",
  "property_seo_description_gallery": "Experience life at The Club at Eagle Pointe, Anchorage! Stylish one-bedroom homes, vibrant amenities, and a community designed for comfort!",
  "property_seo_title_virtualtours": "Virtual Tours | The Club at Eagle Pointe Apartments",
  "property_seo_description_virtualtours": "Experience comfort at The Club at Eagle Pointe in Anchorage, AK. Take a virtual tour to see our inviting one-bedroom apartments and vibrant community today!",
  "property_seo_title_interactivemap": "Interactive Map | The Club at Eagle Pointe Apartments",
  "property_seo_description_interactivemap": "Discover your ideal apartment at The Club at Eagle Pointe in Anchorage! Enjoy spacious layouts, great amenities, and a vibrant community.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Anchorage, AK",
  "property_seo_description_neighborhood": "Unveil the charm of Anchorage at The Club at Eagle Pointe. Discover local favorites and vibrant hotspots just steps from your cozy one-bedroom oasis!",
  "property_seo_title_contact": "Contact Us | The Club at Eagle Pointe",
  "property_seo_description_contact": "Connect with The Club at Eagle Pointe in Anchorage, AK! Inquire about our one-bedroom floor plans today and let our leasing team assist you!",
  "property_seo_title_faqs": "FAQs | Apartments in Anchorage, AK",
  "property_seo_description_faqs": "Find answers to your questions about The Club at Eagle Pointe in Anchorage, AK. Learn about our amenities, floor plans, and resident activities today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Anchorage, AK",
  "property_seo_description_reviews": "Discover The Club at Eagle Pointe in Anchorage, AK! Enjoy spacious one-bedroom apartments and vibrant amenities. Read resident reviews!",
  "property_seo_title_applynow": "Apply Now | Apartments in Anchorage, AK",
  "property_seo_description_applynow": "Discover comfort at The Club at Eagle Pointe, Anchorage! Spacious one-bedroom apartments, premium amenities, vibrant community. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | The Club at Eagle Pointe",
  "property_seo_description_residentaccess": "Login to your resident portal at The Club at Eagle Pointe in Anchorage, AK. Easily manage payments, request maintenance, and connect with your community today!",
  "property_seo_title_referafriend": "Refer A Friend | The Club at Eagle Pointe",
  "property_seo_description_referafriend": "Join The Club at Eagle Pointe in Anchorage, AK—great friends make great neighbors! Refer a friend today and share the joy of exceptional living!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Club at Eagle Pointe",
  "property_seo_description_scheduletour": "Experience the charm of The Club at Eagle Pointe in Anchorage, AK. Book your tour today and envision your new home in our vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | The Club at Eagle Pointe",
  "property_seo_description_privacy": "At The Club at Eagle Pointe, your privacy matters. Discover how we safeguard your information while you enjoy our community. View our policy!",
  "property_seo_title_accessibility": "Website Accessibility | The Club at Eagle Pointe",
  "property_seo_description_accessibility": "At The Club at Eagle Pointe in Anchorage, we prioritize accessibility for all. Join us in creating an inclusive community where everyone thrives.",
  "property_seo_title_sitemap": "Sitemap | The Club at Eagle Pointe",
  "property_seo_description_sitemap": "Navigate your way to your next home at The Club at Eagle Pointe in Anchorage, AK. Check out our sitemap for easy access to amenities and community details!",
  "property_seo_title_thankyou": "Thank You | The Club at Eagle Pointe",
  "property_seo_description_thankyou": "Thank you for reaching out to The Club at Eagle Pointe! Our team will connect soon to help you find your perfect Anchorage home. Excitement awaits!",
  "property_seo_title_pets": "Pet Policy | Apartments in Anchorage, AK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293653964",
  "amenities": [
    {
      "id": "ec_93a98e7dc2864b1f4a1571a0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "yardi",
      "external_id": "87455615",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/01a07a6e-b894-70bb-88f4-10fa17640c24.webp",
      "amenity_image_media": {
        "alt_text": "Lobby area with seating and a round conference table.",
        "public_id": "01a07a6e-b894-70bb-88f4-10fa17640c24",
        "storage_key": "property/6767906449167268/01a07a6e-b894-70bb-88f4-10fa17640c24.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "The Club at Eagle Point Apartments - Lounge",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2130ef95f7334e07f34d9391",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "yardi",
      "external_id": "87455620",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_17efd471387734d187acf643",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "yardi",
      "external_id": "87455622",
      "title": "Fitness Center",
      "amount": "false",
      "description": "20 Hrs Open",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d9a40-b9f4-710b-ac0a-a60100c09f32.webp",
      "amenity_image_media": {
        "alt_text": "Gym with treadmills, elliptical, and stationary bikes",
        "public_id": "019d9a40-b9f4-710b-ac0a-a60100c09f32",
        "storage_key": "property/6767906449167268/019d9a40-b9f4-710b-ac0a-a60100c09f32.webp",
        "width": 1920,
        "height": 1080
      },
      "amenity_image_alt_text": "The Club at Eagle Point Apartments - Fitness Center",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7def31b0456f3f86c636fee1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "yardi",
      "external_id": "87455623",
      "title": "Laundry Room/Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/01a07a6e-b6fd-7007-9d9c-0ec68751b41d.webp",
      "amenity_image_media": {
        "alt_text": "Laundry room with multiple washing machines and dryers, a large sink, and a countertop.",
        "public_id": "01a07a6e-b6fd-7007-9d9c-0ec68751b41d",
        "storage_key": "property/6767906449167268/01a07a6e-b6fd-7007-9d9c-0ec68751b41d.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "The Club at Eagle Point Apartments - Laundry Room",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c987cae51d68e8b1c6dd1a1d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "yardi",
      "external_id": "87455625",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b7475c6bc6b6e87c6b2ce234",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "yardi",
      "external_id": "87455627",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d002247cbe050a0d478c4f44",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "yardi",
      "external_id": "87455614",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6f535038376634d8b7f8c446",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "yardi",
      "external_id": "87455616",
      "title": "Cardio Machines",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a6e6adfae2a2db5f7f21d2df",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "yardi",
      "external_id": "87455617",
      "title": "Coffee Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2bbd35bf4f1fb19729057335",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "yardi",
      "external_id": "87455618",
      "title": "Clubhouse with Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9ae5f9cc8b78116174dc0f2d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "yardi",
      "external_id": "87455619",
      "title": "Courtesy Patrol",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d3d0fdea6d299570fc8b8733",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "yardi",
      "external_id": "87455624",
      "title": "Online Payments & Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_802a092230592e17a55e2fbb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "yardi",
      "external_id": "87455628",
      "title": "Planned Social Activities/ Resident Events",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c034921d79dfe4deafe2a3f3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "yardi",
      "external_id": "87455629",
      "title": "Resident Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/01a07a6e-b756-702c-bee3-3df7f9623873.webp",
      "amenity_image_media": {
        "alt_text": "Lounge area with large leather sectional sofa and fireplace.",
        "public_id": "01a07a6e-b756-702c-bee3-3df7f9623873",
        "storage_key": "property/6767906449167268/01a07a6e-b756-702c-bee3-3df7f9623873.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "The Club at Eagle Point Apartments - Lounge",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a039c8e336b736a7be61d937",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "yardi",
      "external_id": "124799734",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2f215d55b62afe657029b1e5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "yardi",
      "external_id": "87455633",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d9a40-b8eb-775f-bbd0-edb8726c5090.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with closet and view into kitchen and bathroom",
        "public_id": "019d9a40-b8eb-775f-bbd0-edb8726c5090",
        "storage_key": "property/6767906449167268/019d9a40-b8eb-775f-bbd0-edb8726c5090.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "The Club at Eagle Point Apartments - Bedroom",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aec01b0a640bc70fc6d60c12",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "yardi",
      "external_id": "87455637",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e734bac5348ec854f49b7cc3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "yardi",
      "external_id": "87455639",
      "title": "Microwave*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_236af5b8856bdb6383cbcc58",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "yardi",
      "external_id": "87455640",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4b2347843925626cb5e05235",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "yardi",
      "external_id": "87455634",
      "title": "Energy Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_33f58ece5779d329ef7b7d9d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "yardi",
      "external_id": "87455635",
      "title": "Energy Star Certified Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a8ec4cc27a1db9b56cce6d4e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "yardi",
      "external_id": "87455636",
      "title": "Granite Countertops*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/01a07a6e-b82c-7198-9354-4dc67a02f8b5.webp",
      "amenity_image_media": {
        "alt_text": "Bathroom with vanity, sink, toilet, and bathtub.",
        "public_id": "01a07a6e-b82c-7198-9354-4dc67a02f8b5",
        "storage_key": "property/6767906449167268/01a07a6e-b82c-7198-9354-4dc67a02f8b5.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "The Club at Eagle Point Apartments - Bathroom",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8269c02ec14694ae636218f7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "yardi",
      "external_id": "87455638",
      "title": "Linen Closet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_91dac6ea70b67333a83525b1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "yardi",
      "external_id": "87455641",
      "title": "Stainless Steel Appliances*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/01a07a6e-ba0a-76ac-810a-58d780b7e70d.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with light wood cabinets, granite countertops, stainless steel appliances including a microwave, stove, and dishwasher.",
        "public_id": "01a07a6e-ba0a-76ac-810a-58d780b7e70d",
        "storage_key": "property/6767906449167268/01a07a6e-ba0a-76ac-810a-58d780b7e70d.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "The Club at Eagle Point Apartments -",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3c5464831502e2982ba99277",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "yardi",
      "external_id": "87455642",
      "title": "Views",
      "amount": "false",
      "description": "Mountains",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_43aa95c4196f845e16e5396e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/01a07558-2ef7-779c-99ba-87a2f70baa7e.webp",
      "image_media": {
        "alt_text": "Empty bedroom with two bi-fold closets and a ceiling fan.",
        "public_id": "01a07558-2ef7-779c-99ba-87a2f70baa7e",
        "storage_key": "property/6767906449167268/01a07558-2ef7-779c-99ba-87a2f70baa7e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring plush carpeting, ample closet space with bi-fold doors, and a ceiling fan for comfort. A glimpse into the hallway shows a water heater.",
      "link": "false",
      "alt_text": "Empty bedroom with two bi-fold closets and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Club-at-Eagle-Pointe_Favorites (36).jpg"
    },
    {
      "id": "ec_235500011b5712b933d7b0d1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/01a07558-4536-73fc-bb82-c3fc44dfcfe9.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with wooden staircases and balconies.",
        "public_id": "01a07558-4536-73fc-bb82-c3fc44dfcfe9",
        "storage_key": "property/6767906449167268/01a07558-4536-73fc-bb82-c3fc44dfcfe9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming apartment building featuring accessible exterior staircases and balconies, surrounded by mature trees and a clear blue sky.",
      "link": "false",
      "alt_text": "Exterior view of a multi-story apartment building with wooden staircases and balconies.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Club-at-Eagle-Pointe_Favorites (35).jpg"
    },
    {
      "id": "ec_9781a5950e5c6139ac6531ed",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/01a07558-44d9-700e-bff9-c266ada75e41.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, sink, toilet, and bathtub.",
        "public_id": "01a07558-44d9-700e-bff9-c266ada75e41",
        "storage_key": "property/6767906449167268/01a07558-44d9-700e-bff9-c266ada75e41.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and clean bathroom featuring a spacious vanity with a granite countertop, a large mirror, a toilet, and a bathtub/shower combination.",
      "link": "false",
      "alt_text": "Bathroom with vanity, sink, toilet, and bathtub.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Club-at-Eagle-Pointe_Favorites (34).jpg"
    },
    {
      "id": "ec_b8ca70bec76ea4b7a1fbe385",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/01a07558-4664-725c-85b3-826867b8ffd5.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, granite countertops, stainless steel appliances including a microwave, stove, and dishwasher.",
        "public_id": "01a07558-4664-725c-85b3-826867b8ffd5",
        "storage_key": "property/6767906449167268/01a07558-4664-725c-85b3-826867b8ffd5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring ample wooden cabinetry, sleek granite countertops, and a full suite of stainless steel appliances, perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Kitchen with wooden cabinets, granite countertops, stainless steel appliances including a microwave, stove, and dishwasher.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Club-at-Eagle-Pointe_Favorites (33).jpg"
    },
    {
      "id": "ec_d0d2430c7de453240989761f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/01a07558-4535-7018-9abf-6e7daebcba47.webp",
      "image_media": {
        "alt_text": "Empty living room with carpeted floor, white walls, and vertical blinds on the window.",
        "public_id": "01a07558-4535-7018-9abf-6e7daebcba47",
        "storage_key": "property/6767906449167268/01a07558-4535-7018-9abf-6e7daebcba47.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and carpeted living area, perfect for relaxation. Features large window with vertical blinds for natural light control and neutral tones to complement any decor.",
      "link": "false",
      "alt_text": "Empty living room with carpeted floor, white walls, and vertical blinds on the window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Club-at-Eagle-Pointe_Favorites (32).jpg"
    },
    {
      "id": "ec_a6c2afb1fd7bf1a1ffb17f4f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/01a07558-5a4d-7798-a56f-86746b6c32e1.webp",
      "image_media": {
        "alt_text": "Spacious communal lounge area with leather sofas, fireplace, and coffee station.",
        "public_id": "01a07558-5a4d-7798-a56f-86746b6c32e1",
        "storage_key": "property/6767906449167268/01a07558-5a4d-7798-a56f-86746b6c32e1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our comfortable community lounge, featuring plush seating, a cozy fireplace, and convenient amenities for residents.",
      "link": "false",
      "alt_text": "Spacious communal lounge area with leather sofas, fireplace, and coffee station.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Club-at-Eagle-Pointe_Favorites (31).JPG"
    },
    {
      "id": "ec_41f7bd8e515a3e42f2dfbe1b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/01a07558-6d07-750d-b79c-04d64c119ae7.webp",
      "image_media": {
        "alt_text": "Lobby with seating area and reception desk.",
        "public_id": "01a07558-6d07-750d-b79c-04d64c119ae7",
        "storage_key": "property/6767906449167268/01a07558-6d07-750d-b79c-04d64c119ae7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our community lobby, featuring comfortable seating and a reception desk for your convenience.",
      "link": "false",
      "alt_text": "Lobby with seating area and reception desk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Club-at-Eagle-Pointe_Favorites (30).jpg"
    },
    {
      "id": "ec_7c5fdc06eff5a189b0142627",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/01a07558-7668-743a-9b42-59e4c6bc30fb.webp",
      "image_media": {
        "alt_text": "Interior of an apartment showing a closet, kitchen area, and living space.",
        "public_id": "01a07558-7668-743a-9b42-59e4c6bc30fb",
        "storage_key": "property/6767906449167268/01a07558-7668-743a-9b42-59e4c6bc30fb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious apartment living area with an open kitchen, featuring ample closet space and carpeting throughout.",
      "link": "false",
      "alt_text": "Interior of an apartment showing a closet, kitchen area, and living space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Club-at-Eagle-Pointe_Favorites (29).jpg"
    },
    {
      "id": "ec_3fbd6b03a2785051e3370664",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/01a07558-7808-7781-a0f0-be54c1aefa36.webp",
      "image_media": {
        "alt_text": "Laundry room with multiple washers and dryers, utility sinks, and a countertop.",
        "public_id": "01a07558-7808-7781-a0f0-be54c1aefa36",
        "storage_key": "property/6767906449167268/01a07558-7808-7781-a0f0-be54c1aefa36.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities equipped with washers, dryers, and utility sinks for resident use.",
      "link": "false",
      "alt_text": "Laundry room with multiple washers and dryers, utility sinks, and a countertop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Club-at-Eagle-Pointe_Favorites (28).jpg"
    },
    {
      "id": "ec_96b872ef54b8ef6f7e4c9cd0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/01a07558-7942-75c5-bb00-9f3104815fbe.webp",
      "image_media": {
        "alt_text": "Indoor jacuzzi with bubbling water and wooden deck.",
        "public_id": "01a07558-7942-75c5-bb00-9f3104815fbe",
        "storage_key": "property/6767906449167268/01a07558-7942-75c5-bb00-9f3104815fbe.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in the community's private indoor jacuzzi, featuring a soothing bubble massage and a serene wooden deck setting.",
      "link": "false",
      "alt_text": "Indoor jacuzzi with bubbling water and wooden deck.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Club-at-Eagle-Pointe_Favorites (27).JPG"
    },
    {
      "id": "ec_e8ce1a42659f5fabd1e2e315",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/01a07558-880d-756a-97f0-dcaaeeee8f1b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops",
        "public_id": "01a07558-880d-756a-97f0-dcaaeeee8f1b",
        "storage_key": "property/6767906449167268/01a07558-880d-756a-97f0-dcaaeeee8f1b.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "A fully equipped kitchen featuring stainless steel appliances, granite countertops, and ample cabinet space.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and granite countertops",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Club-at-Eagle-Pointe_Favorites (26).jpg"
    },
    {
      "id": "ec_bd6199cd63d9a2abe9212a8f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/01a07558-9888-763e-b062-7eec9a0a1512.webp",
      "image_media": {
        "alt_text": "Interior of a wooden sauna with benches and a light fixture.",
        "public_id": "01a07558-9888-763e-b062-7eec9a0a1512",
        "storage_key": "property/6767906449167268/01a07558-9888-763e-b062-7eec9a0a1512.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Relax and unwind in our community sauna, featuring natural wood finishes and ambient lighting.",
      "link": "false",
      "alt_text": "Interior of a wooden sauna with benches and a light fixture.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Club-at-Eagle-Pointe_Favorites (25).JPG"
    },
    {
      "id": "ec_3c079b6563fd43fb74ecee44",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/01a07558-9b23-766b-89e0-a7680ed8c608.webp",
      "image_media": {
        "alt_text": "Modern kitchen with wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "01a07558-9b23-766b-89e0-a7680ed8c608",
        "storage_key": "property/6767906449167268/01a07558-9b23-766b-89e0-a7680ed8c608.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "A spacious and updated kitchen featuring warm wood cabinetry, sleek granite countertops, and a full suite of stainless steel appliances, perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with wood cabinets, granite countertops, and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Club-at-Eagle-Pointe_Favorites (24).jpg"
    },
    {
      "id": "ec_b6e389f62d985c58fe524729",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/01a07558-a0a5-7283-a530-9f62442618ce.webp",
      "image_media": {
        "alt_text": "Modern living room with a sectional sofa, coffee table, and large window.",
        "public_id": "01a07558-a0a5-7283-a530-9f62442618ce",
        "storage_key": "property/6767906449167268/01a07558-a0a5-7283-a530-9f62442618ce.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious and inviting living room featuring a comfortable sectional sofa, stylish coffee table, and ample natural light from a large window.",
      "link": "false",
      "alt_text": "Modern living room with a sectional sofa, coffee table, and large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Club-at-Eagle-Pointe_Favorites (23).jpg"
    },
    {
      "id": "ec_c7a96ab7a43c28f05c9e103b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/01a07558-a22d-70c0-a27e-69d747bf24ab.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstands, closet, and artwork.",
        "public_id": "01a07558-a22d-70c0-a27e-69d747bf24ab",
        "storage_key": "property/6767906449167268/01a07558-a22d-70c0-a27e-69d747bf24ab.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, ample closet space, and tasteful decor. Enjoy a relaxing retreat in this beautifully appointed room.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, nightstands, closet, and artwork.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Club-at-Eagle-Pointe_Favorites (22).jpg"
    },
    {
      "id": "ec_5a5bbdf4165543c4c43e9115",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/01a07558-a172-735a-9b09-7284112ec79d.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, ellipticals, and stationary bikes.",
        "public_id": "01a07558-a172-735a-9b09-7284112ec79d",
        "storage_key": "property/6767906449167268/01a07558-a172-735a-9b09-7284112ec79d.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with cardio equipment. Enjoy a workout with treadmills, ellipticals, and stationary bikes.",
      "link": "false",
      "alt_text": "Gym with treadmills, ellipticals, and stationary bikes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Club-at-Eagle-Pointe_Favorites (21).jpg"
    },
    {
      "id": "ec_4e2dca76fcd12bfe6cefb8b8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/01a07558-a5d2-751b-b5b2-ee0a8d280b1b.webp",
      "image_media": {
        "alt_text": "Empty room with carpet, a window, and a door.",
        "public_id": "01a07558-a5d2-751b-b5b2-ee0a8d280b1b",
        "storage_key": "property/6767906449167268/01a07558-a5d2-751b-b5b2-ee0a8d280b1b.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "A view of an empty apartment room, showcasing the carpeted flooring, a large window overlooking the outside, and a standard interior door.",
      "link": "false",
      "alt_text": "Empty room with carpet, a window, and a door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Club-at-Eagle-Pointe_Favorites (20).JPG"
    },
    {
      "id": "ec_ac85f2151a9bf94c06cc8d7d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/01a07558-adf9-728d-8672-9a576e7108fc.webp",
      "image_media": {
        "alt_text": "Balcony covered in snow with a view of snow-covered trees and apartment buildings.",
        "public_id": "01a07558-adf9-728d-8672-9a576e7108fc",
        "storage_key": "property/6767906449167268/01a07558-adf9-728d-8672-9a576e7108fc.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Enjoy the winter wonderland from your private balcony, even as snow falls. A perfect view of the community and surrounding natural beauty.",
      "link": "false",
      "alt_text": "Balcony covered in snow with a view of snow-covered trees and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Club-at-Eagle-Pointe_Favorites (19).JPG"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_c39c6ba7-9934-44ae-bc5e-0ac29309a7f6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "DG's Espresso",
      "poi_type": "Restaurants",
      "poi_address": "4201 Lake Otis Pkwy, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-c9d4-73fa-8fc5-bae7912809b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-c9d4-73fa-8fc5-bae7912809b4",
        "storage_key": "property/6767906449167268/019f3eb7-c9d4-73fa-8fc5-bae7912809b4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://instagram.com/dgespresso",
      "poi_directions_map_url": "https://maps.google.com/?cid=7427177092502142851&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dgs-espresso",
      "poi_latitude": "61.1823042",
      "poi_longitude": "-149.837303",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-782-9559",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8458-77ca-9bd8-2fef670a6a2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8458-77ca-9bd8-2fef670a6a2a",
        "storage_key": "property/6767906449167268/019d022c-8458-77ca-9bd8-2fef670a6a2a.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJDdR56aeXyFYRgz-C-jaiEmc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_844b4570-00a4-4b66-a270-86ec51fcf10e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Barbie's Cafe",
      "poi_type": "Restaurants",
      "poi_address": "6728 Lake Otis Pkwy, Anchorage, AK 99507, USA",
      "poi_short_description": "Diner-style restaurant serving homestyle American dishes such as omelettes, chicken-fried steak, and pancakes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-10cb-765c-8b22-891540b1991f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022c-10cb-765c-8b22-891540b1991f",
        "storage_key": "property/6767906449167268/019d022c-10cb-765c-8b22-891540b1991f.webp",
        "width": 1041,
        "height": 885
      },
      "poi_business_url": "http://www.barbiescafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=81934120336670855&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barbies-cafe",
      "poi_latitude": "61.15973899999999",
      "poi_longitude": "-149.8351172",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-344-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8458-77ca-9bd8-30496abd1f8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8458-77ca-9bd8-30496abd1f8d",
        "storage_key": "property/6767906449167268/019d022c-8458-77ca-9bd8-30496abd1f8d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5YgesG-XyFYRh8Cm-aUWIwE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_b8f4c986-4a9e-49f3-911f-eb014c0d713f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Lalo's Pizza Take Out",
      "poi_type": "Restaurants",
      "poi_address": "5915 Lake Otis Pkwy #6, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-ce84-7687-8413-d37b01796350.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-ce84-7687-8413-d37b01796350",
        "storage_key": "property/6767906449167268/019f3eb7-ce84-7687-8413-d37b01796350.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9646638834980904580&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lalos-pizza-take-out",
      "poi_latitude": "61.1672331",
      "poi_longitude": "-149.8363495",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-375-9723",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8458-77ca-9bd8-30496abd1f8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8458-77ca-9bd8-30496abd1f8d",
        "storage_key": "property/6767906449167268/019d022c-8458-77ca-9bd8-30496abd1f8d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4b1VBnOXyFYRhF6GC-m-34U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_490d269d-232a-43fa-bb35-58b066b66b0a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Thai Orchid Alaska",
      "poi_type": "Restaurants",
      "poi_address": "5905 Lake Otis Pkwy A, Anchorage, AK 99507, USA",
      "poi_short_description": "Informal, family-run eatery offering an extensive range of Thai noodles, curries & stir-fries.",
      "poi_long_description": "Informal, family-run eatery offering an extensive range of Thai noodles, curries & stir-fries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-c32e-70ec-9c71-3212fb26b28c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-c32e-70ec-9c71-3212fb26b28c",
        "storage_key": "property/6767906449167268/019f3eb7-c32e-70ec-9c71-3212fb26b28c.webp",
        "width": 1280,
        "height": 1053
      },
      "poi_business_url": "https://thaiorchidalaska.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=7606197115274976236&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thai-orchid-alaska",
      "poi_latitude": "61.1672436",
      "poi_longitude": "-149.8376419",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-868-5226",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8458-77ca-9bd8-30496abd1f8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8458-77ca-9bd8-30496abd1f8d",
        "storage_key": "property/6767906449167268/019d022c-8458-77ca-9bd8-30496abd1f8d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEeVnwNKZyFYR7NuQG_qjjmk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_eeb04877-d8dc-4b38-9462-1e1f1d073418",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Alaska Dinner Factory",
      "poi_type": "Restaurants",
      "poi_address": "5905 Lake Otis Pkwy, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-c39c-7651-96c5-8e979ae3d8df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-c39c-7651-96c5-8e979ae3d8df",
        "storage_key": "property/6767906449167268/019f3eb7-c39c-7651-96c5-8e979ae3d8df.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.alaskadinnerfactory.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11851869280820991841&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-dinner-factory",
      "poi_latitude": "61.1672501",
      "poi_longitude": "-149.8372956",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-677-6633",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8454-7208-a0c7-c6c6e2b895c0",
        "storage_key": "property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy4pfp3OXyFYRYRezJ1FMeqQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "meal_delivery"
    },
    {
      "id": "custom_978af0fe-2c4c-4a03-bc52-58ae6263c7a5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Great Alaska Pizza Company",
      "poi_type": "Restaurants",
      "poi_address": "9220 Lake Otis Pkwy, Anchorage, AK 99507, USA",
      "poi_short_description": "Pizzeria chain serving a menu of classic pies, wings & breadsticks in a low-key setting.",
      "poi_long_description": "Pizzeria chain serving a menu of classic pies, wings & breadsticks in a low-key setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-ca4b-71eb-b326-7a9770d875d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-ca4b-71eb-b326-7a9770d875d8",
        "storage_key": "property/6767906449167268/019f3eb7-ca4b-71eb-b326-7a9770d875d8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.greatalaskapizzacompany.com/anchorage-lake_otis",
      "poi_directions_map_url": "https://maps.google.com/?cid=633595793047525326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "great-alaska-pizza-company",
      "poi_latitude": "61.1369444",
      "poi_longitude": "-149.835",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-349-3733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8458-77ca-9bd8-30496abd1f8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8458-77ca-9bd8-30496abd1f8d",
        "storage_key": "property/6767906449167268/019d022c-8458-77ca-9bd8-30496abd1f8d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAYBBz-aZyFYRzpfHTwT8ygg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_f18efad6-8235-43ab-ad1c-a5fffdb98a3e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Mo's Deli and Catering",
      "poi_type": "Restaurants",
      "poi_address": "9220 Lake Otis Pkwy, Anchorage, AK 99507, USA",
      "poi_short_description": "Kosher, casual space dishing up sandwiches and bagels, plus classic soup options and gluten-free options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-c9e7-7472-b623-6e87360de2f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-c9e7-7472-b623-6e87360de2f3",
        "storage_key": "property/6767906449167268/019f3eb7-c9e7-7472-b623-6e87360de2f3.webp",
        "width": 1280,
        "height": 956
      },
      "poi_business_url": "https://mosdeliak.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=11254154624164878926&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mos-deli-and-catering",
      "poi_latitude": "61.13669710000001",
      "poi_longitude": "-149.8349723",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-868-3354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8877-7427-b0da-51c628672579.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8877-7427-b0da-51c628672579",
        "storage_key": "property/6767906449167268/019d022c-8877-7427-b0da-51c628672579.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjyLZZAuZyFYRTtqq7ADKLpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "deli"
    },
    {
      "id": "custom_f1cc96e8-7fb6-4f60-a0ae-96a17cc79850",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Ichiban Japanese Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2488 E Tudor Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Sushi, sashimi, and other Japanese dishes served in an unpretentious atmosphere.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-c31c-7082-a2a9-bc0efacc5399.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-c31c-7082-a2a9-bc0efacc5399",
        "storage_key": "property/6767906449167268/019f3eb7-c31c-7082-a2a9-bc0efacc5399.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://jiangwei080386.wixsite.com/ichiban-japanese-res",
      "poi_directions_map_url": "https://maps.google.com/?cid=15867101588994769274&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ichiban-japanese-restaurant",
      "poi_latitude": "61.18028859999999",
      "poi_longitude": "-149.8349664",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-563-6333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8458-77ca-9bd8-30496abd1f8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8458-77ca-9bd8-30496abd1f8d",
        "storage_key": "property/6767906449167268/019d022c-8458-77ca-9bd8-30496abd1f8d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLfokOwiXyFYResER49NEM9w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_3693a39d-dff7-4c79-9c45-beefe948845d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "MVP Sports Deli & Eatery",
      "poi_type": "Restaurants",
      "poi_address": "2808 E Tudor Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-ca3d-75d4-be8a-6ce70b0869e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-ca3d-75d4-be8a-6ce70b0869e2",
        "storage_key": "property/6767906449167268/019f3eb7-ca3d-75d4-be8a-6ce70b0869e2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5243022359212812171&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mvp-sports-deli--eatery",
      "poi_latitude": "61.1806016",
      "poi_longitude": "-149.8285731",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-279-7999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8877-7427-b0da-51c628672579.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8877-7427-b0da-51c628672579",
        "storage_key": "property/6767906449167268/019d022c-8877-7427-b0da-51c628672579.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJSV6taUeXyFYRi2dPlg71wkg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "deli"
    },
    {
      "id": "custom_4c020a53-cae4-409a-adf2-3ce51782b429",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Don Jose's Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2052 E Northern Lights Blvd, Anchorage, AK 99508, USA",
      "poi_short_description": "Upbeat eatery & cantina offering familiar Mexican food such as fajitas, burritos & enchiladas.",
      "poi_long_description": "Upbeat eatery & cantina offering familiar Mexican food such as fajitas, burritos & enchiladas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-c839-77bf-8b47-c90589bdc35b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-c839-77bf-8b47-c90589bdc35b",
        "storage_key": "property/6767906449167268/019f3eb7-c839-77bf-8b47-c90589bdc35b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.alaskadonjoses.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4159488084211947592&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "don-joses-mexican-restaurant",
      "poi_latitude": "61.1950028",
      "poi_longitude": "-149.8419563",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-279-5111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8458-77ca-9bd8-30496abd1f8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8458-77ca-9bd8-30496abd1f8d",
        "storage_key": "property/6767906449167268/019d022c-8458-77ca-9bd8-30496abd1f8d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxcDwQqKWyFYRSFjs6l94uTk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_9b6be911-b706-4612-9370-ad16d76770c4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Snow City Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1034 W 4th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Locals call ahead to reserve a seat at this bright eatery serving creative breakfast & lunch fare.",
      "poi_long_description": "Locals call ahead to reserve a seat at this bright eatery serving creative breakfast & lunch fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-23f5-75d2-8e2d-5598f8a0c91b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022c-23f5-75d2-8e2d-5598f8a0c91b",
        "storage_key": "property/6767906449167268/019d022c-23f5-75d2-8e2d-5598f8a0c91b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.snowcitycafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2005746570144512581&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "snow-city-cafe",
      "poi_latitude": "61.2184015",
      "poi_longitude": "-149.9033331",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 907-272-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8458-77ca-9bd8-2fef670a6a2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8458-77ca-9bd8-2fef670a6a2a",
        "storage_key": "property/6767906449167268/019d022c-8458-77ca-9bd8-2fef670a6a2a.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJQcnnU4G9yFYRRfrr7uDX1Rs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_7f5a7d65-32b2-46a9-8adc-fbbf9b1b233a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Moose's Tooth Pub & Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "3300 Old Seward Hwy, Anchorage, AK 99503, USA",
      "poi_short_description": "Inventive pizzas & house-brewed beer served in a bustling, colorful hangout with psychedelic art.",
      "poi_long_description": "Inventive pizzas & house-brewed beer served in a bustling, colorful hangout with psychedelic art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb5-f132-7264-8f84-09e19d629e6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb5-f132-7264-8f84-09e19d629e6b",
        "storage_key": "property/6767906449167268/019f3eb5-f132-7264-8f84-09e19d629e6b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.moosestoothak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15494600602096929900&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mooses-tooth-pub--pizzeria",
      "poi_latitude": "61.1905009",
      "poi_longitude": "-149.8691037",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-258-2537",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8458-77ca-9bd8-30496abd1f8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8458-77ca-9bd8-30496abd1f8d",
        "storage_key": "property/6767906449167268/019d022c-8458-77ca-9bd8-30496abd1f8d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3wBgzrmXyFYRbIyKWCfhB9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_20009b8e-1bc8-49b8-aa73-9297933b5084",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Glacier Brewhouse",
      "poi_type": "Restaurants",
      "poi_address": "737 W 5th Ave #110, Anchorage, AK 99501, USA",
      "poi_short_description": "Boisterous, wood-dominated dining room with local seafood, wood-grilled meats & house-brewed beer.",
      "poi_long_description": "Boisterous, wood-dominated dining room with local seafood, wood-grilled meats & house-brewed beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb5-f58a-7009-a795-a37061f693e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb5-f58a-7009-a795-a37061f693e3",
        "storage_key": "property/6767906449167268/019f3eb5-f58a-7009-a795-a37061f693e3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://glacierbrewhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7378027105723896693&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glacier-brewhouse",
      "poi_latitude": "61.21784590000001",
      "poi_longitude": "-149.8964654",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-274-2739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8458-77ca-9bd8-30496abd1f8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8458-77ca-9bd8-30496abd1f8d",
        "storage_key": "property/6767906449167268/019d022c-8458-77ca-9bd8-30496abd1f8d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7bXHMYe9yFYRdVPg648EZGY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_152fc8ea-6a5b-4f53-b76f-74393546fb23",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Spenard Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "1049 W Northern Lights Blvd, Anchorage, AK 99503, USA",
      "poi_short_description": "Varied fare (such as Thai curry, burgers & pizza), plus beer & cocktails in a bright, casual eatery.",
      "poi_long_description": "Varied fare (such as Thai curry, burgers & pizza), plus beer & cocktails in a bright, casual eatery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb5-f0dc-718a-af3d-3c272f9b48c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb5-f0dc-718a-af3d-3c272f9b48c7",
        "storage_key": "property/6767906449167268/019f3eb5-f0dc-718a-af3d-3c272f9b48c7.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "http://www.spenardroadhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10079478686688268729&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spenard-roadhouse",
      "poi_latitude": "61.19552819999999",
      "poi_longitude": "-149.9032167",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-770-7623",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8458-77ca-9bd8-30496abd1f8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8458-77ca-9bd8-30496abd1f8d",
        "storage_key": "property/6767906449167268/019d022c-8458-77ca-9bd8-30496abd1f8d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFRAGpNuXyFYRudEsUXaA4Ys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_8ae60fb4-42cd-4e1d-bacc-8dcc6d23d8f4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Carrs",
      "poi_type": "Shopping & Retail",
      "poi_address": "1725 Abbott Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Longtime supermarket chain with brand-name & house-label groceries, plus a deli, bakery & pharmacy.",
      "poi_long_description": "Longtime supermarket chain with brand-name & house-label groceries, plus a deli, bakery & pharmacy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-cfa7-71bd-bcac-a188403b416c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-cfa7-71bd-bcac-a188403b416c",
        "storage_key": "property/6767906449167268/019f3eb7-cfa7-71bd-bcac-a188403b416c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://local.carrsqc.com/ak/anchorage/1725-abbott-rd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=14968100458918547655&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carrs",
      "poi_latitude": "61.14205939999999",
      "poi_longitude": "-149.8440099",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-339-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-88c0-71a2-83ce-19e97de3c562.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-88c0-71a2-83ce-19e97de3c562",
        "storage_key": "property/6767906449167268/019d022c-88c0-71a2-83ce-19e97de3c562.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYVcl7t6ZyFYRx5AzIBBguc8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_431561eb-ac3a-458a-a628-08da5cf3b4e2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Fred Meyer",
      "poi_type": "Shopping & Retail",
      "poi_address": "2300 Abbott Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_long_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-d069-757b-8da7-ba4658e24e35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-d069-757b-8da7-ba4658e24e35",
        "storage_key": "property/6767906449167268/019f3eb7-d069-757b-8da7-ba4658e24e35.webp",
        "width": 1280,
        "height": 914
      },
      "poi_business_url": "https://www.fredmeyer.com/stores/grocery/ak/anchorage/southeast-anchorage/701/00656?cid=loc_70100656_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=7143625480901027585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-meyer",
      "poi_latitude": "61.1358972",
      "poi_longitude": "-149.8390961",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-365-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-88c0-71a2-83ce-19e97de3c562.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-88c0-71a2-83ce-19e97de3c562",
        "storage_key": "property/6767906449167268/019d022c-88c0-71a2-83ce-19e97de3c562.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpQGYP-eZyFYRAeeIvYZBI2M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_5e6f8b06-dfe0-45f3-b5de-981512ba7e99",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Bernie's Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4100 Lake Otis Pkwy Ste 200, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-d26e-7563-8f49-bcaf63cf7334.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-d26e-7563-8f49-bcaf63cf7334",
        "storage_key": "property/6767906449167268/019f3eb7-d26e-7563-8f49-bcaf63cf7334.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.berniespharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5819635536112858377&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bernies-pharmacy",
      "poi_latitude": "61.18288150000001",
      "poi_longitude": "-149.8399346",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-562-2138",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8454-7208-a0c7-c128420a4abd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8454-7208-a0c7-c128420a4abd",
        "storage_key": "property/6767906449167268/019d022c-8454-7208-a0c7-c128420a4abd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIaDxMaaXyFYRCTU_tK9_w1A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_d501e28e-22d0-4426-9b9a-3c7ec5ee0427",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "4353 Lake Otis Pkwy, Anchorage, AK 99508, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-d40c-7204-b74c-6b7649dca4c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-d40c-7204-b74c-6b7649dca4c7",
        "storage_key": "property/6767906449167268/019f3eb7-d40c-7204-b74c-6b7649dca4c7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-4353+lake+otis+pkwy-anchorage-ak-99508/id=15653",
      "poi_directions_map_url": "https://maps.google.com/?cid=3593781213064535565&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "61.18140799999999",
      "poi_longitude": "-149.8369517",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-561-2005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8454-7208-a0c7-c6c6e2b895c0",
        "storage_key": "property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC4wykKeXyFYRDR4v_fis3zE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_d359b064-8446-47cf-9763-1705d0cef7e7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Party Time Liquor/Minimart",
      "poi_type": "Shopping & Retail",
      "poi_address": "5520 Lake Otis Pkwy #107, Anchorage, AK 99507, USA",
      "poi_short_description": "Liquor store also selling groceries and snacks with a big selection of name brands.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-2b4e-737c-83d3-7321a126a514.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022c-2b4e-737c-83d3-7321a126a514",
        "storage_key": "property/6767906449167268/019d022c-2b4e-737c-83d3-7321a126a514.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15402384810853511930&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "party-time-liquorminimart",
      "poi_latitude": "61.1705323",
      "poi_longitude": "-149.8387093",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 907-561-2299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8877-7427-b0da-51c628672579.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8877-7427-b0da-51c628672579",
        "storage_key": "property/6767906449167268/019d022c-8877-7427-b0da-51c628672579.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJBandr3SXyFYR-rLLUGFDwNU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "liquor_store"
    },
    {
      "id": "custom_f2b1dfeb-a980-43f2-9f16-d4ee2d7c293f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Bakery Outlet",
      "poi_type": "Restaurants",
      "poi_address": "5520 Lake Otis Pkwy, Anchorage, AK 99507, USA",
      "poi_short_description": "Retail store offering a variety of snacks and breads sold past their sell-by date.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-d343-73ce-a1a8-6ebb5961c4b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-d343-73ce-a1a8-6ebb5961c4b5",
        "storage_key": "property/6767906449167268/019f3eb7-d343-73ce-a1a8-6ebb5961c4b5.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8978949477012851183&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bakery-outlet",
      "poi_latitude": "61.1703137",
      "poi_longitude": "-149.839093",
      "poi_miles_from_property": "0.07",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8458-77ca-9bd8-30496abd1f8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8458-77ca-9bd8-30496abd1f8d",
        "storage_key": "property/6767906449167268/019d022c-8458-77ca-9bd8-30496abd1f8d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSeyBpXSXyFYR78mHEfqim3w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_541bfec7-7879-4c74-afb1-62665c8d2756",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Speedway Express",
      "poi_type": "Transportation & Transit",
      "poi_address": "2811 Seward Hwy, Anchorage, AK 99503, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-d39c-707c-a96d-7c8e33e0edb9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-d39c-707c-a96d-7c8e33e0edb9",
        "storage_key": "property/6767906449167268/019f3eb7-d39c-707c-a96d-7c8e33e0edb9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9098842215300434590&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "speedway-express",
      "poi_latitude": "61.1948899",
      "poi_longitude": "-149.8670703",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-277-6025",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-88b6-723a-85de-c80ae1f05735.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-88b6-723a-85de-c80ae1f05735",
        "storage_key": "property/6767906449167268/019d022c-88b6-723a-85de-c80ae1f05735.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJr2LLObaXyFYRnopPfsmURX4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_db6d503f-c8fb-44e0-be29-3ef968694be3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "6828 Lake Otis Pkwy, Anchorage, AK 99507, USA",
      "poi_short_description": "Gas-station & convenience-store chain stocking snacks, hot foods, beverages & sundries.",
      "poi_long_description": "Gas-station & convenience-store chain stocking snacks, hot foods, beverages & sundries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-d659-720c-b2e5-8cda3a04858f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-d659-720c-b2e5-8cda3a04858f",
        "storage_key": "property/6767906449167268/019f3eb7-d659-720c-b2e5-8cda3a04858f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/anchorage/6828-lake-otis-pkwy/2746625?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=10196893782365558358&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "61.1587131",
      "poi_longitude": "-149.8347862",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-522-1277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-fc94-76a9-928e-623bf67941a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f3eb7-fc94-76a9-928e-623bf67941a5",
        "storage_key": "property/6767906449167268/019f3eb7-fc94-76a9-928e-623bf67941a5.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJI-R3om-XyFYRVtZJnt6kgo0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_4a414db6-e994-4302-b65d-2c355f9e66fc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Dimond Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "800 E Dimond Blvd, Anchorage, AK 99515, USA",
      "poi_short_description": "Family-owned shopping center since 1977, with a bowling alley, food court, ice rink & movie theater.",
      "poi_long_description": "Family-owned shopping center since 1977, with a bowling alley, food court, ice rink & movie theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb5-f3f6-7003-bc8a-a25c3cf1cea8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb5-f3f6-7003-bc8a-a25c3cf1cea8",
        "storage_key": "property/6767906449167268/019f3eb5-f3f6-7003-bc8a-a25c3cf1cea8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.dimondcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1335366531638308692&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dimond-center",
      "poi_latitude": "61.1438157",
      "poi_longitude": "-149.8691231",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-344-2581",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8877-7427-b0da-51c628672579.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8877-7427-b0da-51c628672579",
        "storage_key": "property/6767906449167268/019d022c-8877-7427-b0da-51c628672579.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhwSSWNCZyFYRVC8_E8ksiBI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_fc1189f3-1873-43ca-90c7-ea23ff3d2903",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "4125 DeBarr Rd, Anchorage, AK 99508, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-d40a-729d-85a0-d72d91282c42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-d40a-729d-85a0-d72d91282c42",
        "storage_key": "property/6767906449167268/019f3eb7-d40a-729d-85a0-d72d91282c42.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/anchorage-AK-63.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=6167457813750908994&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "61.2109639",
      "poi_longitude": "-149.8048228",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-269-9510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8877-7427-b0da-51c628672579.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8877-7427-b0da-51c628672579",
        "storage_key": "property/6767906449167268/019d022c-8877-7427-b0da-51c628672579.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJoYf74l6WyFYRQojUezQ2l1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_6bf60ef1-570b-4e35-a52b-b674fdddd8f4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Lake Otis Elementary School",
      "poi_type": "Education",
      "poi_address": "3331 Lake Otis Pkwy, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-d7f8-76ca-8f98-eb0499d0a999.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-d7f8-76ca-8f98-eb0499d0a999",
        "storage_key": "property/6767906449167268/019f3eb7-d7f8-76ca-8f98-eb0499d0a999.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.asdk12.org/lakeotis",
      "poi_directions_map_url": "https://maps.google.com/?cid=8632623473679108982&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-otis-elementary-school",
      "poi_latitude": "61.191039",
      "poi_longitude": "-149.8371852",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-742-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-88b6-723a-85de-c486116ad6e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-88b6-723a-85de-c486116ad6e1",
        "storage_key": "property/6767906449167268/019d022c-88b6-723a-85de-c486116ad6e1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9_zBCayXyFYRdotXzE89zXc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_80ad7f63-433d-42ec-8e4b-e743fb0f0631",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Rilke Schule German Immersion Charter School",
      "poi_type": "Education",
      "poi_address": "8427 Lake Otis Pkwy, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-d7ee-774e-a814-7aa3fadd69c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-d7ee-774e-a814-7aa3fadd69c6",
        "storage_key": "property/6767906449167268/019f3eb7-d7ee-774e-a814-7aa3fadd69c6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.asdk12.org/rilkeschule",
      "poi_directions_map_url": "https://maps.google.com/?cid=11235284931864126377&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rilke-schule-german-immersion-charter-school",
      "poi_latitude": "61.14395909999999",
      "poi_longitude": "-149.8334418",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-742-0900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-88b6-723a-85de-c486116ad6e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-88b6-723a-85de-c486116ad6e1",
        "storage_key": "property/6767906449167268/019d022c-88b6-723a-85de-c486116ad6e1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7yuMdeaZyFYRqWMPUh7A65s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_a937493e-f729-4989-9103-707d5a5b2fb0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Spring Hill Elementary School",
      "poi_type": "Education",
      "poi_address": "9911 Lake Otis Pkwy, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://springhill.asdk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1837689733904170290&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spring-hill-elementary-school",
      "poi_latitude": "61.1331489",
      "poi_longitude": "-149.8297492",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-742-5450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-88b6-723a-85de-c486116ad6e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-88b6-723a-85de-c486116ad6e1",
        "storage_key": "property/6767906449167268/019d022c-88b6-723a-85de-c486116ad6e1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_al-0eWZyFYRMn29lBPJgBk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_d6be4905-68a4-4d11-a916-825d668abd50",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Hanshew Middle School",
      "poi_type": "Education",
      "poi_address": "10121 Lake Otis Pkwy, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.asdk12.org/hanshew",
      "poi_directions_map_url": "https://maps.google.com/?cid=10663501361446957486&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hanshew-middle-school",
      "poi_latitude": "61.13046050000001",
      "poi_longitude": "-149.8308",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-742-9930",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-88b6-723a-85de-c486116ad6e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-88b6-723a-85de-c486116ad6e1",
        "storage_key": "property/6767906449167268/019d022c-88b6-723a-85de-c486116ad6e1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJz1jDgO-ZyFYRrrHwlv1d_JM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_a40e7831-ebb6-42ad-b0a1-e36ef359c1ac",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Service High School",
      "poi_type": "Education",
      "poi_address": "5577 Abbott Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-d96a-769d-8cdd-77458d11f491.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-d96a-769d-8cdd-77458d11f491",
        "storage_key": "property/6767906449167268/019f3eb7-d96a-769d-8cdd-77458d11f491.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.asdk12.org/service",
      "poi_directions_map_url": "https://maps.google.com/?cid=12278618715163057178&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "service-high-school",
      "poi_latitude": "61.13819179999999",
      "poi_longitude": "-149.7813215",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-742-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-88b6-723a-85de-c486116ad6e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-88b6-723a-85de-c486116ad6e1",
        "storage_key": "property/6767906449167268/019d022c-88b6-723a-85de-c486116ad6e1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJv9DYX6yQyFYRGtzBoapqZqo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_fb5dacbb-bc5f-43e8-a8d0-241008d85446",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Crystal Child Development Center - Lake Otis",
      "poi_type": "Education",
      "poi_address": "8620 Lake Otis Pkwy, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-3150-7650-9d8c-24aca3036918.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022c-3150-7650-9d8c-24aca3036918",
        "storage_key": "property/6767906449167268/019d022c-3150-7650-9d8c-24aca3036918.webp",
        "width": 750,
        "height": 500
      },
      "poi_business_url": "http://crystalcdc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16808670366319824867&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crystal-child-development-center---lake-otis",
      "poi_latitude": "61.1427267",
      "poi_longitude": "-149.8350278",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-770-2643",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-88b6-723a-85de-c486116ad6e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-88b6-723a-85de-c486116ad6e1",
        "storage_key": "property/6767906449167268/019d022c-88b6-723a-85de-c486116ad6e1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJh3lhC-CZyFYR488gW6RkROk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_91453d88-b383-4618-bc52-458e7722d231",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Pacific Northern Academy",
      "poi_type": "Education",
      "poi_address": "2511 Sentry Dr, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.pacificnorthern.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=206734834740584442&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pacific-northern-academy",
      "poi_latitude": "61.1333745",
      "poi_longitude": "-149.8356213",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-88b6-723a-85de-c486116ad6e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-88b6-723a-85de-c486116ad6e1",
        "storage_key": "property/6767906449167268/019d022c-88b6-723a-85de-c486116ad6e1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJW969xGeWyFYR-l9pozx43gI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_8e960778-6e02-4530-b51d-a9adb8a04e6a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Unite Church",
      "poi_type": "Education",
      "poi_address": "2626 Abbott Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-db80-771d-b9b0-215d3bb83ca5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-db80-771d-b9b0-215d3bb83ca5",
        "storage_key": "property/6767906449167268/019f3eb7-db80-771d-b9b0-215d3bb83ca5.webp",
        "width": 1280,
        "height": 1242
      },
      "poi_business_url": "http://unitechurchak.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12522430873979974408&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "unite-church",
      "poi_latitude": "61.1370555",
      "poi_longitude": "-149.8330443",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-349-9641",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-fc92-70a8-9d83-12b9be796afe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f3eb7-fc92-70a8-9d83-12b9be796afe",
        "storage_key": "property/6767906449167268/019f3eb7-fc92-70a8-9d83-12b9be796afe.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJmyfgyLKZyFYRCPP1f4icyK0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "custom_fc2de6be-8de8-4241-984b-eb8afd315a78",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "University of Alaska Anchorage",
      "poi_type": "Education",
      "poi_address": "3211 Providence Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb5-f2b1-721d-b842-7a1dc0471cc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb5-f2b1-721d-b842-7a1dc0471cc8",
        "storage_key": "property/6767906449167268/019f3eb5-f2b1-721d-b842-7a1dc0471cc8.webp",
        "width": 672,
        "height": 400
      },
      "poi_business_url": "https://www.uaa.alaska.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2963319407001083725&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-alaska-anchorage",
      "poi_latitude": "61.1910421",
      "poi_longitude": "-149.8195598",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-786-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-88b6-723a-85de-c486116ad6e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-88b6-723a-85de-c486116ad6e1",
        "storage_key": "property/6767906449167268/019d022c-88b6-723a-85de-c486116ad6e1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8bmy6gCXyFYRTR9S4kzTHyk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_65301299-e560-41b6-bda5-bdc531513744",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Imagination Station",
      "poi_type": "Education",
      "poi_address": "300 E 56th Ave, Anchorage, AK 99518, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.imaginationstation.biz/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6431038714583262448&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "imagination-station",
      "poi_latitude": "61.1698295",
      "poi_longitude": "-149.876629",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-563-8290",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-88b6-723a-85de-c486116ad6e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-88b6-723a-85de-c486116ad6e1",
        "storage_key": "property/6767906449167268/019d022c-88b6-723a-85de-c486116ad6e1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB7JshZqXyFYR8CSFR6OjP1k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_20f5c080-e2f2-4ac9-bbaa-2c1ba83c658e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Alaska Zoo",
      "poi_type": "Entertainment",
      "poi_address": "4731 O'Malley Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Zoo exhibiting a wide range of native Alaskan mammals & birds, plus exotics such as tigers & camels.",
      "poi_long_description": "Zoo exhibiting a wide range of native Alaskan mammals & birds, plus exotics such as tigers & camels.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb5-fc12-7338-85e1-3bc9ffc5f8ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb5-fc12-7338-85e1-3bc9ffc5f8ea",
        "storage_key": "property/6767906449167268/019f3eb5-fc12-7338-85e1-3bc9ffc5f8ea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.alaskazoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11640787335481525738&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-zoo",
      "poi_latitude": "61.1238025",
      "poi_longitude": "-149.7907",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8454-7208-a0c7-c6c6e2b895c0",
        "storage_key": "property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH2Yh-ASayFYR6gU-9WdijKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_f6fff57a-9d0c-4adc-b56d-1fa9c3bc8b53",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Alaska Native Heritage Center",
      "poi_type": "Entertainment",
      "poi_address": "8800 Heritage Center Dr, Anchorage, AK 99504, USA",
      "poi_short_description": "Exhibits, films & demonstrations of native culture, plus a woodland area with traditional dwellings.",
      "poi_long_description": "Exhibits, films & demonstrations of native culture, plus a woodland area with traditional dwellings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-3c66-756a-82e8-18cb3193718a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022c-3c66-756a-82e8-18cb3193718a",
        "storage_key": "property/6767906449167268/019d022c-3c66-756a-82e8-18cb3193718a.webp",
        "width": 992,
        "height": 744
      },
      "poi_business_url": "http://www.alaskanative.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2030269464598956769&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-heritage-center",
      "poi_latitude": "61.2327673",
      "poi_longitude": "-149.7172142",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 907-330-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8454-7208-a0c7-c6c6e2b895c0",
        "storage_key": "property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa0B1BT2UyFYR4Uq-O1L3LBw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cultural_center"
    },
    {
      "id": "custom_2ffea370-e049-483e-b971-730706c13291",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Alaska Aviation Museum",
      "poi_type": "Entertainment",
      "poi_address": "4721 Aircraft Dr, Anchorage, AK 99502, USA",
      "poi_short_description": "Historic aircraft (which guests may see being restored), plus exhibits, films & a flight simulator.",
      "poi_long_description": "Historic aircraft (which guests may see being restored), plus exhibits, films & a flight simulator.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb5-fce7-719e-8acd-7b80f58729c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb5-fce7-719e-8acd-7b80f58729c9",
        "storage_key": "property/6767906449167268/019f3eb5-fce7-719e-8acd-7b80f58729c9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.alaskaairmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15162667059188171085&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-aviation-museum",
      "poi_latitude": "61.1793565",
      "poi_longitude": "-149.9719066",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 907-248-5325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8c64-7076-894e-374dd9a8519b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8c64-7076-894e-374dd9a8519b",
        "storage_key": "property/6767906449167268/019d022c-8c64-7076-894e-374dd9a8519b.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJExnfV029yFYRTYFt5lqdbNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_f828bab8-33aa-47bc-bfe4-ba7db3eaf807",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Bear Tooth Theatrepub",
      "poi_type": "Entertainment",
      "poi_address": "1230 W 27th Ave, Anchorage, AK 99503, USA",
      "poi_short_description": "2nd-run & indie moviehouse (that also hosts concerts) serving microbrews, wine & casual eats.",
      "poi_long_description": "2nd-run & indie moviehouse (that also hosts concerts) serving microbrews, wine & casual eats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-de93-7428-b33e-da84ed6e91a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-de93-7428-b33e-da84ed6e91a9",
        "storage_key": "property/6767906449167268/019f3eb7-de93-7428-b33e-da84ed6e91a9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.beartoothak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10145190151877577635&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bear-tooth-theatrepub",
      "poi_latitude": "61.1959573",
      "poi_longitude": "-149.9070452",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-276-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8d5d-76ba-933e-85cfe9999243.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8d5d-76ba-933e-85cfe9999243",
        "storage_key": "property/6767906449167268/019d022c-8d5d-76ba-933e-85cfe9999243.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJM_p-3NuXyFYRo0t0DbH0yow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_713286c6-5a84-459d-a5d7-22bd66d321ec",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Anchorage Museum",
      "poi_type": "Entertainment",
      "poi_address": "625 C St, Anchorage, AK 99501, USA",
      "poi_short_description": "Alaskan artifacts & artworks, plus a kid-friendly, hands-on science center & planetarium.",
      "poi_long_description": "Alaskan artifacts & artworks, plus a kid-friendly, hands-on science center & planetarium.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-4200-723a-ab62-3c71e17bbde0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022c-4200-723a-ab62-3c71e17bbde0",
        "storage_key": "property/6767906449167268/019d022c-4200-723a-ab62-3c71e17bbde0.webp",
        "width": 1280,
        "height": 795
      },
      "poi_business_url": "http://www.anchoragemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6288654669058341295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-museum",
      "poi_latitude": "61.2162281",
      "poi_longitude": "-149.8855791",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-929-9200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8c64-7076-894e-374dd9a8519b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8c64-7076-894e-374dd9a8519b",
        "storage_key": "property/6767906449167268/019d022c-8c64-7076-894e-374dd9a8519b.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJjUPnbCmWyFYRr_lSUBrKRVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_e5d5fa24-fdcf-4b40-badd-b6f6446500a5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Alaska Botanical Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4601 Campbell Airstrip Road, Anchorage, AK 99507, USA",
      "poi_short_description": "Trails guide visitors through a boreal forest to 11 acres of cultivated gardens with native flora.",
      "poi_long_description": "Trails guide visitors through a boreal forest to 11 acres of cultivated gardens with native flora.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-5649-7366-871e-3b741194e8e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022c-5649-7366-871e-3b741194e8e8",
        "storage_key": "property/6767906449167268/019d022c-5649-7366-871e-3b741194e8e8.webp",
        "width": 976,
        "height": 662
      },
      "poi_business_url": "http://www.alaskabg.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5929108756512643080&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-botanical-garden",
      "poi_latitude": "61.17777439999999",
      "poi_longitude": "-149.7615572",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-770-3692",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8454-7208-a0c7-c6c6e2b895c0",
        "storage_key": "property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-wU15deWyFYRCBiYEgBtSFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_7900e965-7b41-4afe-82c2-6839108ba26f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Kincaid Outdoor Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9401 Raspberry Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-df4d-734b-899d-cabc5d27603a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-df4d-734b-899d-cabc5d27603a",
        "storage_key": "property/6767906449167268/019f3eb7-df4d-734b-899d-cabc5d27603a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.muni.org/Departments/parks/Pages/Kincaid.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=4482038648302601019&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kincaid-outdoor-center",
      "poi_latitude": "61.15422419999999",
      "poi_longitude": "-150.0565216",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 907-343-6397",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8454-7208-a0c7-c6c6e2b895c0",
        "storage_key": "property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS0U0ufCiyFYROwOmXWdmMz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "picnic_ground"
    },
    {
      "id": "custom_4d576cfa-1541-490c-8796-2948e2fd3395",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Alaska Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "621 W 6th Ave Suite ACPA, Anchorage, AK 99501, USA",
      "poi_short_description": "Large venue with 3 theaters hosting a range of events, from dance recitals to symphonies to plays.",
      "poi_long_description": "Large venue with 3 theaters hosting a range of events, from dance recitals to symphonies to plays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-422d-73cb-a632-18c66acf3648.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022c-422d-73cb-a632-18c66acf3648",
        "storage_key": "property/6767906449167268/019d022c-422d-73cb-a632-18c66acf3648.webp",
        "width": 1152,
        "height": 648
      },
      "poi_business_url": "https://www.alaskapac.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14135362058056830395&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-center-for-the-performing-arts",
      "poi_latitude": "61.2170565",
      "poi_longitude": "-149.8943133",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-263-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8454-7208-a0c7-c6c6e2b895c0",
        "storage_key": "property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAcZ2Uoe9yFYRuw0DQubkKsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_11deafe7-5e40-47d5-84c3-3ab94aa44dfb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Dena’ina Civic and Convention Center",
      "poi_type": "Entertainment",
      "poi_address": "600 W 7th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Located within the Dena'ina Civic and Convention Center, this facility hosts events such as conventions, concerts, and boat shows.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-e074-719d-8d81-b9da4a043813.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-e074-719d-8d81-b9da4a043813",
        "storage_key": "property/6767906449167268/019f3eb7-e074-719d-8d81-b9da4a043813.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://denaina.anchorageconventioncenters.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13102333279014608095&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "denaina-civic-and-convention-center",
      "poi_latitude": "61.2154727",
      "poi_longitude": "-149.8946224",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-263-2850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8454-7208-a0c7-c6c6e2b895c0",
        "storage_key": "property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRaMkCiqWyFYR39xxuLLW1LU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convention_center"
    },
    {
      "id": "custom_754e29de-d994-4bd8-8dd9-a88483c92205",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Tony Knowles Coastal Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Raspberry Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "Scenic biking and hiking trail also popular with joggers, featuring views of the coast and wildlife, plus bike rentals.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-e013-7158-a2ca-d4aa047b6b96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-e013-7158-a2ca-d4aa047b6b96",
        "storage_key": "property/6767906449167268/019f3eb7-e013-7158-a2ca-d4aa047b6b96.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://anchoragecoastaltrail.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=557379505387354668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tony-knowles-coastal-trail",
      "poi_latitude": "61.15420659999999",
      "poi_longitude": "-150.0597526",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-fc94-76a9-928e-5d1ad415ad22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f3eb7-fc94-76a9-928e-5d1ad415ad22",
        "storage_key": "property/6767906449167268/019f3eb7-fc94-76a9-928e-5d1ad415ad22.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJVx7NAvqiyFYRLDqy_7Q1vAc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_171c0cb9-d33a-4970-9d85-d4cd76f181cf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Providence Alaska Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3200 Providence Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb6-07de-77c8-9d02-5093b798ffc1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb6-07de-77c8-9d02-5093b798ffc1",
        "storage_key": "property/6767906449167268/019f3eb6-07de-77c8-9d02-5093b798ffc1.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.providence.org/locations/ak/alaska-medical-center?ls=location&y_source=1_OTU3NTY4Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1990875543032169585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-alaska-medical-center",
      "poi_latitude": "61.1866256",
      "poi_longitude": "-149.8221354",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-562-2211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8d9d-759b-bcf4-123ace35741f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8d9d-759b-bcf4-123ace35741f",
        "storage_key": "property/6767906449167268/019d022c-8d9d-759b-bcf4-123ace35741f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__razgCXyFYRcQRyHsICoRs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_acef8547-12d6-43ac-8036-f720da7076b5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Alaska Native Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4315 Diplomacy Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-475f-757a-b6fb-d1e80aebd20c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022c-475f-757a-b6fb-d1e80aebd20c",
        "storage_key": "property/6767906449167268/019d022c-475f-757a-b6fb-d1e80aebd20c.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://anmc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12633987291157363904&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-medical-center",
      "poi_latitude": "61.182452",
      "poi_longitude": "-149.8002427",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-563-2662",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8d9d-759b-bcf4-123ace35741f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8d9d-759b-bcf4-123ace35741f",
        "storage_key": "property/6767906449167268/019d022c-8d9d-759b-bcf4-123ace35741f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJV_bUZRyXyFYRwPw76oDwVK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_5276cc5f-a8e1-4a38-8d05-325d1e6f583f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Primary Care Associates - Lake Otis",
      "poi_type": "Health and Wellness",
      "poi_address": "4100 Lake Otis Pkwy #322, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-e39d-70f8-920e-38b941b05a52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-e39d-70f8-920e-38b941b05a52",
        "storage_key": "property/6767906449167268/019f3eb7-e39d-70f8-920e-38b941b05a52.webp",
        "width": 1075,
        "height": 1280
      },
      "poi_business_url": "http://primarycareak.com/?utm_source=GMBSocialClimb&utm_medium=PrimaryCareAssociates",
      "poi_directions_map_url": "https://maps.google.com/?cid=7619180546658642422&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primary-care-associates---lake-otis",
      "poi_latitude": "61.1830671",
      "poi_longitude": "-149.8401302",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-562-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8454-7208-a0c7-c6c6e2b895c0",
        "storage_key": "property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_3eJNKaXyFYR9qkny1bEvGk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_e326de61-308b-40dc-8148-aa183818679b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4353 Lake Otis Pkwy, Anchorage, AK 99508, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-e525-7039-a542-4af4c41029af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-e525-7039-a542-4af4c41029af",
        "storage_key": "property/6767906449167268/019f3eb7-e525-7039-a542-4af4c41029af.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-4353+lake+otis+pkwy-anchorage-ak-99508/id=15653",
      "poi_directions_map_url": "https://maps.google.com/?cid=3152525370068096305&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "61.1814142",
      "poi_longitude": "-149.8369777",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-561-2005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8454-7208-a0c7-c128420a4abd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8454-7208-a0c7-c128420a4abd",
        "storage_key": "property/6767906449167268/019d022c-8454-7208-a0c7-c128420a4abd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfWPvkKeXyFYRMdVQDB8FwCs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_dff37b09-94d6-4fc0-9916-38b68d7c8c22",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "YMCA of Alaska Lake Otis",
      "poi_type": "Health and Wellness",
      "poi_address": "5353 Lake Otis Pkwy, Anchorage, AK 99507, USA",
      "poi_short_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_long_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-4c4b-72b6-8b0a-327c8f3d3477.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022c-4c4b-72b6-8b0a-327c8f3d3477",
        "storage_key": "property/6767906449167268/019d022c-4c4b-72b6-8b0a-327c8f3d3477.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "https://www.ymcaalaska.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17258879203027320348&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ymca-of-alaska-lake-otis",
      "poi_latitude": "61.1721592",
      "poi_longitude": "-149.8364442",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 907-563-3211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8454-7208-a0c7-c6c6e2b895c0",
        "storage_key": "property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJze1RgwyXyFYRHP7RlTHbg-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_464e28d7-154f-48bf-ba27-123c5f6c760b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8936 Lake Otis Pkwy, Anchorage, AK 99507, USA",
      "poi_short_description": "Chain fitness center offering 24-hour access, personal training, and group workouts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-4c4c-7654-afb0-9d6d04122085.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022c-4c4c-7654-afb0-9d6d04122085",
        "storage_key": "property/6767906449167268/019d022c-4c4c-7654-afb0-9d6d04122085.webp",
        "width": 768,
        "height": 1024
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/anchorage-alaska-4023/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=4023",
      "poi_directions_map_url": "https://maps.google.com/?cid=15154378622549450527&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "61.1397399",
      "poi_longitude": "-149.8351745",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-600-2611",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8454-7208-a0c7-c6c6e2b895c0",
        "storage_key": "property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR5JjnF6ZyFYRH1_V3BArT9I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6f21057b-1a48-463d-a13b-e11fd25c6e5e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "The Alaska Club East Gym & Pool",
      "poi_type": "Health and Wellness",
      "poi_address": "5201 E Tudor Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "This fitness center features a swimming pool along with a racquetball court and an indoor tennis court.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-51bf-73be-8f03-d094802dc019.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022c-51bf-73be-8f03-d094802dc019",
        "storage_key": "property/6767906449167268/019d022c-51bf-73be-8f03-d094802dc019.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.thealaskaclub.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp-taceast-profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=13441179354482565633&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-alaska-club-east-gym--pool",
      "poi_latitude": "61.181272",
      "poi_longitude": "-149.7830598",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-337-9550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8454-7208-a0c7-c6c6e2b895c0",
        "storage_key": "property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-8ujJiCXyFYRAWI_kmipiLo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_46b9d113-9635-4a36-8e01-d1ba5d65dee9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Anchorage Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "701 W 36th Ave, Anchorage, AK 99503, USA",
      "poi_short_description": "Studio offering yoga classes for beginners and experienced students, plus massage services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb6-07f4-74b8-a170-463218fc8829.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb6-07f4-74b8-a170-463218fc8829",
        "storage_key": "property/6767906449167268/019f3eb6-07f4-74b8-a170-463218fc8829.webp",
        "width": 852,
        "height": 1280
      },
      "poi_business_url": "http://anchorageyoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1189873777368163935&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-yoga",
      "poi_latitude": "61.18870920000001",
      "poi_longitude": "-149.8964094",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-562-9642",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-88b6-723a-85de-c486116ad6e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-88b6-723a-85de-c486116ad6e1",
        "storage_key": "property/6767906449167268/019d022c-88b6-723a-85de-c486116ad6e1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ90egSsKXyFYRX-aUc-VHgxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_abb959ec-da4d-4909-a6d3-096e0a9ab2ee",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Lake Otis Medical Supply",
      "poi_type": "Shopping & Retail",
      "poi_address": "4201 Lake Otis Pkwy, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-e776-720e-ae10-2799c6fb3fe6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-e776-720e-ae10-2799c6fb3fe6",
        "storage_key": "property/6767906449167268/019f3eb7-e776-720e-ae10-2799c6fb3fe6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://lakeotismedical.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3797430296749753565&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-otis-medical-supply",
      "poi_latitude": "61.1823657",
      "poi_longitude": "-149.8372814",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-563-7801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8877-7427-b0da-51c628672579.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8877-7427-b0da-51c628672579",
        "storage_key": "property/6767906449167268/019d022c-8877-7427-b0da-51c628672579.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ03_xw6eXyFYR3UQTObwuszQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_20e6924d-7ca2-46f9-9794-cc40b91ac939",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Lake Otis Buffer Park North",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4900 Lake Otis Pkwy, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3773664093858691854&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-otis-buffer-park-north",
      "poi_latitude": "61.1764461",
      "poi_longitude": "-149.8384528",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8db5-77b7-bf7c-78cbdfff45c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8db5-77b7-bf7c-78cbdfff45c5",
        "storage_key": "property/6767906449167268/019d022c-8db5-77b7-bf7c-78cbdfff45c5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWQHoPAqXyFYRDvsX6H-_XjQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_f610f2d2-028f-43e9-b399-fabed16a9dc8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Tikishla Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3018 E 20th Ave, Anchorage, AK 99508, USA",
      "poi_short_description": "As well as sports fields & playgrounds, this park has acres of forest, stream, meadow & wetlands.",
      "poi_long_description": "As well as sports fields & playgrounds, this park has acres of forest, stream, meadow & wetlands.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-e581-7281-bdd2-a69787930684.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-e581-7281-bdd2-a69787930684",
        "storage_key": "property/6767906449167268/019f3eb7-e581-7281-bdd2-a69787930684.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8343908419687385749&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tikishla-park",
      "poi_latitude": "61.202521",
      "poi_longitude": "-149.8256393",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8db5-77b7-bf7c-78cbdfff45c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8db5-77b7-bf7c-78cbdfff45c5",
        "storage_key": "property/6767906449167268/019d022c-8db5-77b7-bf7c-78cbdfff45c5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJFeQCMlKWyFYRlYrb8X-Ey3M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_73056f71-df94-4331-806a-43c185f80e66",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Taku Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "100 E 76th Ave, Anchorage, AK 99518, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-e9f0-709f-a30b-6e79981435fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-e9f0-709f-a30b-6e79981435fc",
        "storage_key": "property/6767906449167268/019f3eb7-e9f0-709f-a30b-6e79981435fc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5677825898772991912&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taku-lake-park",
      "poi_latitude": "61.1518789",
      "poi_longitude": "-149.8802031",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-fc94-76a9-928e-5d1ad415ad22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f3eb7-fc94-76a9-928e-5d1ad415ad22",
        "storage_key": "property/6767906449167268/019f3eb7-fc94-76a9-928e-5d1ad415ad22.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJb5fBHwCZyFYRqI_gkJKwy04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_a03cf845-ff40-4423-88bd-d6a7d6ddfbcb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "University Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4050 University Lake Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "Off-leash dog park featuring a trail with picnic tables and a lake.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-e9d6-7077-a32b-66ae58649607.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-e9d6-7077-a32b-66ae58649607",
        "storage_key": "property/6767906449167268/019f3eb7-e9d6-7077-a32b-66ae58649607.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14589859302453206728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-lake-park",
      "poi_latitude": "61.1848311",
      "poi_longitude": "-149.8077434",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8db5-77b7-bf7c-78cbdfff45c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8db5-77b7-bf7c-78cbdfff45c5",
        "storage_key": "property/6767906449167268/019d022c-8db5-77b7-bf7c-78cbdfff45c5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJu_rUugKXyFYRyN6mNbyXeco",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_d8ba6622-aa2e-43eb-9bec-1995834f8821",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Abbott Loop Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8101 Elmore Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Popular park featuring baseball fields, trails, playgrounds and picnic tables.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-e84a-7161-b757-13f1b608eb60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-e84a-7161-b757-13f1b608eb60",
        "storage_key": "property/6767906449167268/019f3eb7-e84a-7161-b757-13f1b608eb60.webp",
        "width": 300,
        "height": 400
      },
      "poi_business_url": "https://www.muni.org/Departments/parks/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=9564194593061388731&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "abbott-loop-community-park",
      "poi_latitude": "61.14740860000001",
      "poi_longitude": "-149.801292",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8db5-77b7-bf7c-78cbdfff45c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8db5-77b7-bf7c-78cbdfff45c5",
        "storage_key": "property/6767906449167268/019d022c-8db5-77b7-bf7c-78cbdfff45c5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvbRib1CXyFYRu8EiIk_YuoQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_abc6b15b-d7a1-43a3-b798-1f37ff3b7db3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Campbell Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2365 E 48th Ave, Anchorage, AK 99507, USA",
      "poi_short_description": "Park with a playground, creeks and trails that accommodate various activities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-51d6-70a9-93b5-ed9aeda3ce00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022c-51d6-70a9-93b5-ed9aeda3ce00",
        "storage_key": "property/6767906449167268/019d022c-51d6-70a9-93b5-ed9aeda3ce00.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://anchorageparkfoundation.org/footer/completed-projects/campbell-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1172772302220400418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "campbell-creek-park",
      "poi_latitude": "61.17745050000001",
      "poi_longitude": "-149.8370751",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8db5-77b7-bf7c-78cbdfff45c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8db5-77b7-bf7c-78cbdfff45c5",
        "storage_key": "property/6767906449167268/019d022c-8db5-77b7-bf7c-78cbdfff45c5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJH7nDjQmXyFYRIpdD_DGGRhA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_9a984347-0d1a-4c32-a89e-c6620a72c34d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Bancroft Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1497 Alpenhorn Ave, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-ec2e-76f2-a63c-900da56aecf3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-ec2e-76f2-a63c-900da56aecf3",
        "storage_key": "property/6767906449167268/019f3eb7-ec2e-76f2-a63c-900da56aecf3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8274834841495366802&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bancroft-park",
      "poi_latitude": "61.17369189999999",
      "poi_longitude": "-149.8551955",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8db5-77b7-bf7c-78cbdfff45c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8db5-77b7-bf7c-78cbdfff45c5",
        "storage_key": "property/6767906449167268/019d022c-8db5-77b7-bf7c-78cbdfff45c5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ87Y7OZ-XyFYRkmxbRnIe1nI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_35e06dc4-b6b7-49bc-a674-5cb7d189fe7a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Carlson Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2214 Stanford Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-ee1a-73d1-96c3-8d5cc0a1d25f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-ee1a-73d1-96c3-8d5cc0a1d25f",
        "storage_key": "property/6767906449167268/019f3eb7-ee1a-73d1-96c3-8d5cc0a1d25f.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8867902283096501309&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carlson-park",
      "poi_latitude": "61.19196269999999",
      "poi_longitude": "-149.8406538",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8db5-77b7-bf7c-78cbdfff45c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8db5-77b7-bf7c-78cbdfff45c5",
        "storage_key": "property/6767906449167268/019d022c-8db5-77b7-bf7c-78cbdfff45c5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJXxzGXa6XyFYRPazXbiQeEXs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e0b1a322-b07b-41d2-b84d-cfe940a8640b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Chuck Albrecht Softball Complex",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4781 Elmore Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Local field primarily dedicated to softball.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-ec9f-7048-870e-1f496c52c150.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-ec9f-7048-870e-1f496c52c150",
        "storage_key": "property/6767906449167268/019f3eb7-ec9f-7048-870e-1f496c52c150.webp",
        "width": 1280,
        "height": 1029
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8148659757603048112&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chuck-albrecht-softball-complex",
      "poi_latitude": "61.1763377",
      "poi_longitude": "-149.8036721",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8454-7208-a0c7-c6c6e2b895c0",
        "storage_key": "property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ8U6ihqXyFYRsEpzR-DaFXE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "athletic_field"
    },
    {
      "id": "custom_a93ab1db-bcd1-403b-93ce-6fbe234d7b8b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Cuddy Family Midtown Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "201 E 40th Ave, Anchorage, AK 99503, USA",
      "poi_short_description": "Park with a colorful playground, exercise track, pond, a small amphitheater & seasonal ice skating.",
      "poi_long_description": "Park with a colorful playground, exercise track, pond, a small amphitheater & seasonal ice skating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-ee91-76cc-bb9e-1231c504e46a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-ee91-76cc-bb9e-1231c504e46a",
        "storage_key": "property/6767906449167268/019f3eb7-ee91-76cc-bb9e-1231c504e46a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.alaska.org/detail/cuddy-family-midtown-park#photos",
      "poi_directions_map_url": "https://maps.google.com/?cid=4525791115162483285&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cuddy-family-midtown-park",
      "poi_latitude": "61.18422299999999",
      "poi_longitude": "-149.880937",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8db5-77b7-bf7c-78cbdfff45c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8db5-77b7-bf7c-78cbdfff45c5",
        "storage_key": "property/6767906449167268/019d022c-8db5-77b7-bf7c-78cbdfff45c5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ8sKob-XyFYRVfrgYgrXzj4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d2cb9e10-43a5-42d1-a26d-1542e9698104",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Dimond Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-f143-7362-9ca4-b76a6f645424.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-f143-7362-9ca4-b76a6f645424",
        "storage_key": "property/6767906449167268/019f3eb7-f143-7362-9ca4-b76a6f645424.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17211653549311854446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dimond-transit-center",
      "poi_latitude": "61.142764",
      "poi_longitude": "-149.871953",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-fc92-70a8-9d83-150bb8e718aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f3eb7-fc92-70a8-9d83-150bb8e718aa",
        "storage_key": "property/6767906449167268/019f3eb7-fc92-70a8-9d83-150bb8e718aa.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJyVAwvdGZyFYRbgfTO7YT3O4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_1d64c867-2644-48cd-83c0-4508cfb336f2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Downtown Transit Center Pass",
      "poi_type": "Transportation & Transit",
      "poi_address": "700 W 6th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-f0e2-778a-8880-80591ff1e998.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-f0e2-778a-8880-80591ff1e998",
        "storage_key": "property/6767906449167268/019f3eb7-f0e2-778a-8880-80591ff1e998.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.peoplemover.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11500851897172059445&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-transit-center-pass",
      "poi_latitude": "61.21588799999999",
      "poi_longitude": "-149.8964133",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-343-6543",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8454-7208-a0c7-c6c6e2b895c0",
        "storage_key": "property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq2bquYC9yFYRNWVRyd07m58",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_ded8e385-09ee-40c2-9d38-e49d1d85903b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Anchorage Depot",
      "poi_type": "Transportation & Transit",
      "poi_address": "411 W 1st Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Classic train station built in the 1940s featuring model train displays, a gift shop & scenic rides.",
      "poi_long_description": "Classic train station built in the 1940s featuring model train displays, a gift shop & scenic rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb6-0eec-75d8-a409-17fdced93a1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb6-0eec-75d8-a409-17fdced93a1a",
        "storage_key": "property/6767906449167268/019f3eb6-0eec-75d8-a409-17fdced93a1a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.alaskarailroad.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3741649916070368533&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-depot",
      "poi_latitude": "61.22168490000001",
      "poi_longitude": "-149.8904657",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 800-544-0552",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-9049-737e-85e3-ede55cd19a49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-9049-737e-85e3-ede55cd19a49",
        "storage_key": "property/6767906449167268/019d022c-9049-737e-85e3-ede55cd19a49.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJfd_0CYi9yFYRFZU-ScYC7TM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_61bcf8ec-c7a1-492d-9ac2-92eff3fa6364",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Ted Stevens Anchorage International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5000 W International Airport Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "Built in 1951, flights from this airport can reach 90% of the industrialized world within 9.5 hours.",
      "poi_long_description": "Built in 1951, flights from this airport can reach 90% of the industrialized world within 9.5 hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb6-0d4a-766f-94db-dbde8b95025b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb6-0d4a-766f-94db-dbde8b95025b",
        "storage_key": "property/6767906449167268/019f3eb6-0d4a-766f-94db-dbde8b95025b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://dot.alaska.gov/anc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10860248208626249647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ted-stevens-anchorage-international-airport",
      "poi_latitude": "61.1769173",
      "poi_longitude": "-149.9905923",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 907-266-2526",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-90fa-704c-b827-a4b93fb2b856.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-90fa-704c-b827-a4b93fb2b856",
        "storage_key": "property/6767906449167268/019d022c-90fa-704c-b827-a4b93fb2b856.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJERqXa7WiyFYRr2-9pzRat5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_f8cae00f-15dc-47bf-af22-120e07e98d0a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Alaska Regional Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2801 DeBarr Rd, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-690e-730f-bb57-d4c0a9d41bf4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022c-690e-730f-bb57-d4c0a9d41bf4",
        "storage_key": "property/6767906449167268/019d022c-690e-730f-bb57-d4c0a9d41bf4.webp",
        "width": 911,
        "height": 512
      },
      "poi_business_url": "https://www.alaskaregional.com/?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1047679142014347636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-regional-hospital",
      "poi_latitude": "61.2106829",
      "poi_longitude": "-149.8283619",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-276-1131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8d9d-759b-bcf4-123ace35741f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8d9d-759b-bcf4-123ace35741f",
        "storage_key": "property/6767906449167268/019d022c-8d9d-759b-bcf4-123ace35741f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJKYPSVUSWyFYRdOlZ-qAaig4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_d5bea5a4-b1e4-4fec-8c03-cea3b761b64b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Alaska Native Tribal Health Consortium",
      "poi_type": "Health and Wellness",
      "poi_address": "4000 Ambassador Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-6739-770d-a0fc-30cb5203837d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022c-6739-770d-a0fc-30cb5203837d",
        "storage_key": "property/6767906449167268/019d022c-6739-770d-a0fc-30cb5203837d.webp",
        "width": 1280,
        "height": 301
      },
      "poi_business_url": "http://www.anthc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1002423738872135572&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-tribal-health-consortium",
      "poi_latitude": "61.18400399999999",
      "poi_longitude": "-149.7994651",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-729-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8454-7208-a0c7-c6c6e2b895c0",
        "storage_key": "property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ7c0qhyXyFYRlH_kVRRT6Q0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_61dee85d-b8ec-453b-aa31-3cfbbca63892",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Military and Family Readiness Center (JBER-R)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "600 Richardson Dr B346, Fort Richardson, AK 99505, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-f35a-7159-b4d4-1772d0873834.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-f35a-7159-b4d4-1772d0873834",
        "storage_key": "property/6767906449167268/019f3eb7-f35a-7159-b4d4-1772d0873834.webp",
        "width": 1280,
        "height": 768
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10517719877101561708&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "military-and-family-readiness-center-jber-r",
      "poi_latitude": "61.25467339999999",
      "poi_longitude": "-149.6932134",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 48 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 907-384-1517",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8454-7208-a0c7-c6c6e2b895c0",
        "storage_key": "property/6767906449167268/019d022c-8454-7208-a0c7-c6c6e2b895c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVVVZWTyFYRbCe0wYBy9pE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_a1f0c322-1335-461f-8094-9b04b73defb6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Alaska VA Healthcare System",
      "poi_type": "Health and Wellness",
      "poi_address": "1201 N Muldoon Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-f511-726d-b984-9dc2f2b573fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-f511-726d-b984-9dc2f2b573fe",
        "storage_key": "property/6767906449167268/019f3eb7-f511-726d-b984-9dc2f2b573fe.webp",
        "width": 1280,
        "height": 550
      },
      "poi_business_url": "http://www.alaska.va.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3646700986371871179&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-va-healthcare-system",
      "poi_latitude": "61.2327171",
      "poi_longitude": "-149.744364",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 907-257-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-8d9d-759b-bcf4-123ace35741f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-8d9d-759b-bcf4-123ace35741f",
        "storage_key": "property/6767906449167268/019d022c-8d9d-759b-bcf4-123ace35741f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJt9v_0CiUyFYRyxHD3jmvmzI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_6861b6fe-1a87-4dbe-b430-203dda3b1397",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Anchorage City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "632 W 6th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb6-1275-776b-af8f-37992cc7cb84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb6-1275-776b-af8f-37992cc7cb84",
        "storage_key": "property/6767906449167268/019f3eb6-1275-776b-af8f-37992cc7cb84.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.muni.org/pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=1064156177697528647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-city-hall",
      "poi_latitude": "61.21632990000001",
      "poi_longitude": "-149.8948221",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-343-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-9114-771e-9306-965f9c469ab2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-9114-771e-9306-965f9c469ab2",
        "storage_key": "property/6767906449167268/019d022c-9114-771e-9306-965f9c469ab2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQDkroC9yFYRR9syzWekxA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_181c6183-783a-4df1-a72a-3dd12a27531e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "poi_name": "Anchorage School District",
      "poi_type": "Education",
      "poi_address": "5530 E Northern Lights Blvd, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f3eb7-f4d9-73d9-bd87-076f0295f287.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3eb7-f4d9-73d9-bd87-076f0295f287",
        "storage_key": "property/6767906449167268/019f3eb7-f4d9-73d9-bd87-076f0295f287.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.asdk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11253021771947721235&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-school-district",
      "poi_latitude": "61.1939631",
      "poi_longitude": "-149.7754994",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-742-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019d022c-88b6-723a-85de-c486116ad6e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022c-88b6-723a-85de-c486116ad6e1",
        "storage_key": "property/6767906449167268/019d022c-88b6-723a-85de-c486116ad6e1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc3ueb-mWyFYRE0KuNq7DKpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_68c06d29c8543db3d84dc415",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_94c53022e13f07fa5d6412cc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_6b6fb3c9cb48fa0cc3409222",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_238d81ade36dddf654789229",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_68a28db22b2a0efc7150a91a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_cc6ebb34f9315bbbcb81d156",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "rating": "5",
      "name": "Lon Petty",
      "text": "Welcome to the club at Eagle Point. This team here is amazing. Even though they're new, they're still amazand if you pay your rent on time, you'll never have problems.\nAnd with the help of the exercise room, I have managed to lose over 36 pounds and we still trying to lose 12 more and why would I want to live anywhere else in the Anchorage Alaska",
      "date": "2025-04-16",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_19751ea3-40cf-4512-82e3-4c3b1a298a62",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019f8626-90ab-7549-ac41-f3f76e8cdbe5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f8626-90ab-7549-ac41-f3f76e8cdbe5",
        "storage_key": "property/6767906449167268/019f8626-90ab-7549-ac41-f3f76e8cdbe5.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "The Club At Eagle Point - Club House",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=GzLbE9j729j"
    },
    {
      "id": "custom_4cdfa60e-e998-49eb-87f4-7f6a8fabc2ca",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019ddcfe-8b49-7241-aed4-0f928af6dea7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcfe-8b49-7241-aed4-0f928af6dea7",
        "storage_key": "property/6767906449167268/019ddcfe-8b49-7241-aed4-0f928af6dea7.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Eagles Nest",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=avxgAkqmgWK"
    },
    {
      "id": "custom_072e4335-39ee-4548-ad92-2a391c3ab7e4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167268/019ddcfe-8cf3-7392-9b1f-c87dab4781b8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcfe-8cf3-7392-9b1f-c87dab4781b8",
        "storage_key": "property/6767906449167268/019ddcfe-8cf3-7392-9b1f-c87dab4781b8.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Eagles Nest Remodeled",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Q1zuXsHLsw5"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019f95f3-7cad-704c-8e1e-c2ee9a28dc3a",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "The Club at Eagle Pointe Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-eagle-point",
      "search_query": "fitness center apartments anchorage",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Anchorage",
      "h2_subtitle": "Discover fitness center apartments at The Club at Eagle Point. Perfectly located in the heart of Anchorage, these homes offer unparalleled convenience.",
      "page_copy": "Looking for fitness center apartments in Anchorage? The Club at Eagle Point offers an active community lifestyle nestled in the charming Campbell Park neighborhood. While our property does not have a fitness center on-site, residents enjoy planned social activities and events, creating a vibrant, health-conscious community. \n\nEach apartment boasts modern amenities like granite countertops and convenient features such as a microwave and linen closets. Located in Anchorage Municipality, The Club at Eagle Point enables easy access to outdoor fitness opportunities. Explore everything Anchorage has to offer while making the most of our welcoming community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in Anchorage",
      "seo_description": "Discover apartments near Anchorage's fitness centers at The Club at Eagle Point, surrounded by vibrant community activities and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "generator",
      "page_item_url": "clubhouse-wifi-eagle-point-anchorage",
      "search_query": "clubhouse with wi-fi anchorage ak",
      "category": "Amenity",
      "h1_title": "Clubhouse with Wi-Fi in Anchorage, AK",
      "h2_subtitle": "Enjoy a clubhouse with Wi-Fi at The Club at Eagle Point in Anchorage, AK. Connect and unwind in our welcoming community spaces.",
      "page_copy": "In search of a clubhouse with Wi-Fi in Anchorage, AK? The Club at Eagle Point is the ideal choice. Situated in the lively Campbell Park area, our community offers a perfect blend of connectivity and comfort. While we provide numerous modern amenities like granite countertops and microwaves, our planned resident events ensure you’re always engaged.\n\nResidents enjoy access to laundry facilities and spacious linen closets, enhancing the convenience of apartment living. Although our community doesn't feature a dedicated Wi-Fi-enabled clubhouse, the surrounding Anchorage Municipality offers a variety of options for entertainment and relaxation. Experience a sense of belonging at The Club at Eagle Point, where community and convenience converge.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Clubhouse with Wi-Fi in Anchorage, AK",
      "seo_description": "Find your ideal home at The Club at Eagle Point in Anchorage, AK. Enjoy modern amenities and a welcoming community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "generator",
      "page_item_url": "sauna-apartments-campbell-park",
      "search_query": "sauna apartments near campbell park",
      "category": "Amenity",
      "h1_title": "Sauna Apartments Near Campbell Park",
      "h2_subtitle": "Explore sauna apartments near Campbell Park at The Club at Eagle Point. Enjoy community events and modern amenities in Anchorage.",
      "page_copy": "If you're searching for sauna apartments near Campbell Park, consider The Club at Eagle Point. While our community doesn't feature a sauna, we offer a vibrant lifestyle near this popular Anchorage neighborhood. Our residents enjoy planned social activities and events, enriching the community atmosphere.\n\nOur apartments are equipped with contemporary features, including granite countertops, microwaves, and ample storage like linen closets. Located in the Anchorage Municipality, The Club at Eagle Point provides easy access to the amenities of Campbell Park, making it a great choice for those seeking both comfort and a convenient location in Anchorage, AK.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sauna Apartments Near Campbell Park",
      "seo_description": "Discover apartments near Campbell Park at The Club at Eagle Point with modern amenities and community events, perfect for an active lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "generator",
      "page_item_url": "energy-efficient-apartments-99507-eagle-point",
      "search_query": "energy efficient apartments 99507",
      "category": "Amenity",
      "h1_title": "Energy Efficient Apartments in 99507",
      "h2_subtitle": "Explore energy efficient apartments in the 99507 area at The Club at Eagle Point. Live sustainably without compromising on comfort and style.",
      "page_copy": "Looking for energy efficient apartments in the 99507 area? The Club at Eagle Point offers a sustainable living option in the heart of Anchorage’s Campbell Park neighborhood. Our modern homes feature energy-saving amenities and contemporary features like granite countertops and microwaves, helping you live comfortably while reducing environmental impact.\n\nIn addition to energy efficiency, residents enjoy practical spaces with linen closets and access to laundry facilities, making everyday living convenient. Our vibrant community atmosphere is complemented by planned social activities and events, ensuring a lively yet eco-friendly lifestyle in Anchorage, AK.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Energy Efficient Apartments in 99507",
      "seo_description": "Find energy efficient apartments at The Club at Eagle Point, located in Anchorage’s 99507. Enjoy sustainable living with modern comforts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "generator",
      "page_item_url": "granite-countertops-apartments-anchorage",
      "search_query": "granite countertops apartments anchorage municipality",
      "category": "Amenity",
      "h1_title": "Granite Countertops Apartments Anchorage",
      "h2_subtitle": "Discover apartments with granite countertops in the Anchorage Municipality. The Club at Eagle Point offers modern comforts in a welcoming community.",
      "page_copy": "For those seeking apartments with granite countertops in the Anchorage Municipality, The Club at Eagle Point is the perfect choice. Our homes feature sleek and modern designs, offering the elegance of granite countertops alongside practical amenities such as microwaves and spacious linen closets.\n\nLocated in the vibrant Campbell Park area, our community promotes a lively atmosphere with planned social activities and resident events. Along with convenient laundry facilities, our Anchorage apartments are designed to offer both style and function, ensuring a comfortable lifestyle within our welcoming neighborhood.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Granite Countertops Apartments Anchorage",
      "seo_description": "Find modern apartments with granite countertops at The Club at Eagle Point, located in Anchorage Municipality, offering comfort and community events.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167268",
      "source": "generator",
      "page_item_url": "one-bedroom-apartment-campbell-park",
      "search_query": "one bedroom apartment Campbell Park Anchorage",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartment in Campbell Park",
      "h2_subtitle": "Find a cozy one bedroom apartment in Campbell Park, Anchorage. Discover modern amenities and a vibrant community at The Club at Eagle Point.",
      "page_copy": "Searching for a one bedroom apartment in Campbell Park, Anchorage? Look no further than The Club at Eagle Point, where comfort meets convenience in a vibrant community. Our one-bedroom apartments offer modern living with features like granite countertops and built-in microwaves, ensuring a stylish yet functional home.\n\nLocated in the heart of Anchorage, our community thrives on social connections, hosting regular resident events that bring neighbors together. With ample storage solutions such as linen closets and laundry facilities on-site, you'll find everything you need for a cozy and organized lifestyle right here in Campbell Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartment in Campbell Park",
      "seo_description": "Discover one bedroom apartments at The Club at Eagle Point, located in Campbell Park, Anchorage, offering stylish living and community events.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309896210"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9073085613"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KZXW85GR"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 6"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "93d2b2d7-a2d0-4a48-894b-894dd1ad0805"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/3862a4e6-0b98-4df2-a818-7784d08fc442/app.js?property=3862a4e6-0b98-4df2-a818-7784d08fc442&propertyName=The+Club+at+Eagle+Point&channelUuid=c248fc1f-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47586141841"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Im91VzMrc2VxTVkrb0lZTG1ZQUhuMlE9PSIsInZhbHVlIjoiQkQ0QU01MThWNlBYZVVxMmJYSDJ0UT09IiwibWFjIjoiY2M3YmRlMjNkZTM1MDdjMmRiMmNjNDdkZTQyNDQxYzM4NTQ1YzE5NzNmYmM3YjIyMDZiOGI3MTA3OGUxMTAxNiJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309896210",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9073085613",
  "custom_google_gtm_id": "GTM-KZXW85GR",
  "custom_rollout_phase": "Phase 6",
  "custom_rentgrata_token": "93d2b2d7-a2d0-4a48-894b-894dd1ad0805",
  "custom_vibesites_theme": "Preferred",
  "custom_ads_subscription": "none",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/3862a4e6-0b98-4df2-a818-7784d08fc442/app.js?property=3862a4e6-0b98-4df2-a818-7784d08fc442&propertyName=The+Club+at+Eagle+Point&channelUuid=c248fc1f-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47586141841",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Im91VzMrc2VxTVkrb0lZTG1ZQUhuMlE9PSIsInZhbHVlIjoiQkQ0QU01MThWNlBYZVVxMmJYSDJ0UT09IiwibWFjIjoiY2M3YmRlMjNkZTM1MDdjMmRiMmNjNDdkZTQyNDQxYzM4NTQ1YzE5NzNmYmM3YjIyMDZiOGI3MTA3OGUxMTAxNiJ9",
  "custom_audioeye_site_id": "715c7697-508e-49ee-8a0d-710c9c432f9d",
  "custom_audioeye_site_hash": "67e63f9931bd067110ab0cf494b84179"
};

export const generatedAt = '2026-10-27T16:59:11.755Z';
